// Datos de Departamentos, Provincias y Distritos de Perú
// Fuente: INEI (vía repositorio joseluisq/ubigeos-peru)
// Actualizado: 2026-02-06

export const departamentos = [
  {
    "id": "01",
    "nombre": "Amazonas"
  },
  {
    "id": "02",
    "nombre": "Ancash"
  },
  {
    "id": "03",
    "nombre": "Apurimac"
  },
  {
    "id": "04",
    "nombre": "Arequipa"
  },
  {
    "id": "05",
    "nombre": "Ayacucho"
  },
  {
    "id": "06",
    "nombre": "Cajamarca"
  },
  {
    "id": "07",
    "nombre": "Callao"
  },
  {
    "id": "08",
    "nombre": "Cusco"
  },
  {
    "id": "09",
    "nombre": "Huancavelica"
  },
  {
    "id": "10",
    "nombre": "Huanuco"
  },
  {
    "id": "11",
    "nombre": "Ica"
  },
  {
    "id": "12",
    "nombre": "Junin"
  },
  {
    "id": "13",
    "nombre": "La Libertad"
  },
  {
    "id": "14",
    "nombre": "Lambayeque"
  },
  {
    "id": "15",
    "nombre": "Lima"
  },
  {
    "id": "16",
    "nombre": "Loreto"
  },
  {
    "id": "17",
    "nombre": "Madre de Dios"
  },
  {
    "id": "18",
    "nombre": "Moquegua"
  },
  {
    "id": "19",
    "nombre": "Pasco"
  },
  {
    "id": "20",
    "nombre": "Piura"
  },
  {
    "id": "21",
    "nombre": "Puno"
  },
  {
    "id": "22",
    "nombre": "San Martin"
  },
  {
    "id": "23",
    "nombre": "Tacna"
  },
  {
    "id": "24",
    "nombre": "Tumbes"
  },
  {
    "id": "25",
    "nombre": "Ucayali"
  }
];

export const provincias = {
  "10": [
    {
      "id": "1001",
      "nombre": "Huanuco"
    },
    {
      "id": "1002",
      "nombre": "Ambo"
    },
    {
      "id": "1003",
      "nombre": "Dos de Mayo"
    },
    {
      "id": "1004",
      "nombre": "Huacaybamba"
    },
    {
      "id": "1005",
      "nombre": "Huamalies"
    },
    {
      "id": "1006",
      "nombre": "Leoncio Prado"
    },
    {
      "id": "1007",
      "nombre": "Maraqon"
    },
    {
      "id": "1008",
      "nombre": "Pachitea"
    },
    {
      "id": "1009",
      "nombre": "Puerto Inca"
    },
    {
      "id": "1010",
      "nombre": "Lauricocha"
    },
    {
      "id": "1011",
      "nombre": "Yarowilca"
    }
  ],
  "11": [
    {
      "id": "1101",
      "nombre": "Ica"
    },
    {
      "id": "1102",
      "nombre": "Chincha"
    },
    {
      "id": "1103",
      "nombre": "Nazca"
    },
    {
      "id": "1104",
      "nombre": "Palpa"
    },
    {
      "id": "1105",
      "nombre": "Pisco"
    }
  ],
  "12": [
    {
      "id": "1201",
      "nombre": "Huancayo"
    },
    {
      "id": "1202",
      "nombre": "Concepcion"
    },
    {
      "id": "1203",
      "nombre": "Chanchamayo"
    },
    {
      "id": "1204",
      "nombre": "Jauja"
    },
    {
      "id": "1205",
      "nombre": "Junin"
    },
    {
      "id": "1206",
      "nombre": "Satipo"
    },
    {
      "id": "1207",
      "nombre": "Tarma"
    },
    {
      "id": "1208",
      "nombre": "Yauli"
    },
    {
      "id": "1209",
      "nombre": "Chupaca"
    }
  ],
  "13": [
    {
      "id": "1301",
      "nombre": "Trujillo"
    },
    {
      "id": "1302",
      "nombre": "Ascope"
    },
    {
      "id": "1303",
      "nombre": "Bolivar"
    },
    {
      "id": "1304",
      "nombre": "Chepen"
    },
    {
      "id": "1305",
      "nombre": "Julcan"
    },
    {
      "id": "1306",
      "nombre": "Otuzco"
    },
    {
      "id": "1307",
      "nombre": "Pacasmayo"
    },
    {
      "id": "1308",
      "nombre": "Pataz"
    },
    {
      "id": "1309",
      "nombre": "Sanchez Carrion"
    },
    {
      "id": "1310",
      "nombre": "Santiago de Chuco"
    },
    {
      "id": "1311",
      "nombre": "Gran Chimu"
    },
    {
      "id": "1312",
      "nombre": "Viru"
    }
  ],
  "14": [
    {
      "id": "1401",
      "nombre": "Chiclayo"
    },
    {
      "id": "1402",
      "nombre": "Ferreqafe"
    },
    {
      "id": "1403",
      "nombre": "Lambayeque"
    }
  ],
  "15": [
    {
      "id": "1501",
      "nombre": "Lima"
    },
    {
      "id": "1502",
      "nombre": "Barranca"
    },
    {
      "id": "1503",
      "nombre": "Cajatambo"
    },
    {
      "id": "1504",
      "nombre": "Canta"
    },
    {
      "id": "1505",
      "nombre": "Cañete"
    },
    {
      "id": "1506",
      "nombre": "Huaral"
    },
    {
      "id": "1507",
      "nombre": "Huarochiri"
    },
    {
      "id": "1508",
      "nombre": "Huaura"
    },
    {
      "id": "1509",
      "nombre": "Oyon"
    },
    {
      "id": "1510",
      "nombre": "Yauyos"
    }
  ],
  "16": [
    {
      "id": "1601",
      "nombre": "Maynas"
    },
    {
      "id": "1602",
      "nombre": "Alto Amazonas"
    },
    {
      "id": "1603",
      "nombre": "Loreto"
    },
    {
      "id": "1604",
      "nombre": "Mariscal Ramon Castilla"
    },
    {
      "id": "1605",
      "nombre": "Requena"
    },
    {
      "id": "1606",
      "nombre": "Ucayali"
    }
  ],
  "17": [
    {
      "id": "1701",
      "nombre": "Tambopata"
    },
    {
      "id": "1702",
      "nombre": "Manu"
    },
    {
      "id": "1703",
      "nombre": "Tahuamanu"
    }
  ],
  "18": [
    {
      "id": "1801",
      "nombre": "Mariscal Nieto"
    },
    {
      "id": "1802",
      "nombre": "General Sanchez Cerro"
    },
    {
      "id": "1803",
      "nombre": "Ilo"
    }
  ],
  "19": [
    {
      "id": "1901",
      "nombre": "Pasco"
    },
    {
      "id": "1902",
      "nombre": "Daniel Alcides Carrion"
    },
    {
      "id": "1903",
      "nombre": "Oxapampa"
    }
  ],
  "20": [
    {
      "id": "2001",
      "nombre": "Piura"
    },
    {
      "id": "2002",
      "nombre": "Ayabaca"
    },
    {
      "id": "2003",
      "nombre": "Huancabamba"
    },
    {
      "id": "2004",
      "nombre": "Morropon"
    },
    {
      "id": "2005",
      "nombre": "Paita"
    },
    {
      "id": "2006",
      "nombre": "Sullana"
    },
    {
      "id": "2007",
      "nombre": "Talara"
    },
    {
      "id": "2008",
      "nombre": "Sechura"
    }
  ],
  "21": [
    {
      "id": "2101",
      "nombre": "Puno"
    },
    {
      "id": "2102",
      "nombre": "Azangaro"
    },
    {
      "id": "2103",
      "nombre": "Carabaya"
    },
    {
      "id": "2104",
      "nombre": "Chucuito"
    },
    {
      "id": "2105",
      "nombre": "El Collao"
    },
    {
      "id": "2106",
      "nombre": "Huancane"
    },
    {
      "id": "2107",
      "nombre": "Lampa"
    },
    {
      "id": "2108",
      "nombre": "Melgar"
    },
    {
      "id": "2109",
      "nombre": "Moho"
    },
    {
      "id": "2110",
      "nombre": "San Antonio de Putina"
    },
    {
      "id": "2111",
      "nombre": "San Roman"
    },
    {
      "id": "2112",
      "nombre": "Sandia"
    },
    {
      "id": "2113",
      "nombre": "Yunguyo"
    }
  ],
  "22": [
    {
      "id": "2201",
      "nombre": "Moyobamba"
    },
    {
      "id": "2202",
      "nombre": "Bellavista"
    },
    {
      "id": "2203",
      "nombre": "El Dorado"
    },
    {
      "id": "2204",
      "nombre": "Huallaga"
    },
    {
      "id": "2205",
      "nombre": "Lamas"
    },
    {
      "id": "2206",
      "nombre": "Mariscal Caceres"
    },
    {
      "id": "2207",
      "nombre": "Picota"
    },
    {
      "id": "2208",
      "nombre": "Rioja"
    },
    {
      "id": "2209",
      "nombre": "San Martin"
    },
    {
      "id": "2210",
      "nombre": "Tocache"
    }
  ],
  "23": [
    {
      "id": "2301",
      "nombre": "Tacna"
    },
    {
      "id": "2302",
      "nombre": "Candarave"
    },
    {
      "id": "2303",
      "nombre": "Jorge Basadre"
    },
    {
      "id": "2304",
      "nombre": "Tarata"
    }
  ],
  "24": [
    {
      "id": "2401",
      "nombre": "Tumbes"
    },
    {
      "id": "2402",
      "nombre": "Contralmirante Villar"
    },
    {
      "id": "2403",
      "nombre": "Zarumilla"
    }
  ],
  "25": [
    {
      "id": "2501",
      "nombre": "Coronel Portillo"
    },
    {
      "id": "2502",
      "nombre": "Atalaya"
    },
    {
      "id": "2503",
      "nombre": "Padre Abad"
    },
    {
      "id": "2504",
      "nombre": "Purus"
    }
  ],
  "01": [
    {
      "id": "0101",
      "nombre": "Chachapoyas"
    },
    {
      "id": "0102",
      "nombre": "Bagua"
    },
    {
      "id": "0103",
      "nombre": "Bongara"
    },
    {
      "id": "0104",
      "nombre": "Condorcanqui"
    },
    {
      "id": "0105",
      "nombre": "Luya"
    },
    {
      "id": "0106",
      "nombre": "Rodriguez de Mendoza"
    },
    {
      "id": "0107",
      "nombre": "Utcubamba"
    }
  ],
  "02": [
    {
      "id": "0201",
      "nombre": "Huaraz"
    },
    {
      "id": "0202",
      "nombre": "Aija"
    },
    {
      "id": "0203",
      "nombre": "Antonio Raymondi"
    },
    {
      "id": "0204",
      "nombre": "Asuncion"
    },
    {
      "id": "0205",
      "nombre": "Bolognesi"
    },
    {
      "id": "0206",
      "nombre": "Carhuaz"
    },
    {
      "id": "0207",
      "nombre": "Carlos Fermin Fitzcarrald"
    },
    {
      "id": "0208",
      "nombre": "Casma"
    },
    {
      "id": "0209",
      "nombre": "Corongo"
    },
    {
      "id": "0210",
      "nombre": "Huari"
    },
    {
      "id": "0211",
      "nombre": "Huarmey"
    },
    {
      "id": "0212",
      "nombre": "Huaylas"
    },
    {
      "id": "0213",
      "nombre": "Mariscal Luzuriaga"
    },
    {
      "id": "0214",
      "nombre": "Ocros"
    },
    {
      "id": "0215",
      "nombre": "Pallasca"
    },
    {
      "id": "0216",
      "nombre": "Pomabamba"
    },
    {
      "id": "0217",
      "nombre": "Recuay"
    },
    {
      "id": "0218",
      "nombre": "Santa"
    },
    {
      "id": "0219",
      "nombre": "Sihuas"
    },
    {
      "id": "0220",
      "nombre": "Yungay"
    }
  ],
  "03": [
    {
      "id": "0301",
      "nombre": "Abancay"
    },
    {
      "id": "0302",
      "nombre": "Andahuaylas"
    },
    {
      "id": "0303",
      "nombre": "Antabamba"
    },
    {
      "id": "0304",
      "nombre": "Aymaraes"
    },
    {
      "id": "0305",
      "nombre": "Cotabambas"
    },
    {
      "id": "0306",
      "nombre": "Chincheros"
    },
    {
      "id": "0307",
      "nombre": "Grau"
    }
  ],
  "04": [
    {
      "id": "0401",
      "nombre": "Arequipa"
    },
    {
      "id": "0402",
      "nombre": "Camana"
    },
    {
      "id": "0403",
      "nombre": "Caraveli"
    },
    {
      "id": "0404",
      "nombre": "Castilla"
    },
    {
      "id": "0405",
      "nombre": "Caylloma"
    },
    {
      "id": "0406",
      "nombre": "Condesuyos"
    },
    {
      "id": "0407",
      "nombre": "Islay"
    },
    {
      "id": "0408",
      "nombre": "La Union"
    }
  ],
  "05": [
    {
      "id": "0501",
      "nombre": "Huamanga"
    },
    {
      "id": "0502",
      "nombre": "Cangallo"
    },
    {
      "id": "0503",
      "nombre": "Huanca Sancos"
    },
    {
      "id": "0504",
      "nombre": "Huanta"
    },
    {
      "id": "0505",
      "nombre": "La Mar"
    },
    {
      "id": "0506",
      "nombre": "Lucanas"
    },
    {
      "id": "0507",
      "nombre": "Parinacochas"
    },
    {
      "id": "0508",
      "nombre": "Paucar del Sara Sara"
    },
    {
      "id": "0509",
      "nombre": "Sucre"
    },
    {
      "id": "0510",
      "nombre": "Victor Fajardo"
    },
    {
      "id": "0511",
      "nombre": "Vilcas Huaman"
    }
  ],
  "06": [
    {
      "id": "0601",
      "nombre": "Cajamarca"
    },
    {
      "id": "0602",
      "nombre": "Cajabamba"
    },
    {
      "id": "0603",
      "nombre": "Celendin"
    },
    {
      "id": "0604",
      "nombre": "Chota"
    },
    {
      "id": "0605",
      "nombre": "Contumaza"
    },
    {
      "id": "0606",
      "nombre": "Cutervo"
    },
    {
      "id": "0607",
      "nombre": "Hualgayoc"
    },
    {
      "id": "0608",
      "nombre": "Jaen"
    },
    {
      "id": "0609",
      "nombre": "San Ignacio"
    },
    {
      "id": "0610",
      "nombre": "San Marcos"
    },
    {
      "id": "0611",
      "nombre": "San Miguel"
    },
    {
      "id": "0612",
      "nombre": "San Pablo"
    },
    {
      "id": "0613",
      "nombre": "Santa Cruz"
    }
  ],
  "07": [
    {
      "id": "0701",
      "nombre": "Callao"
    }
  ],
  "08": [
    {
      "id": "0801",
      "nombre": "Cusco"
    },
    {
      "id": "0802",
      "nombre": "Acomayo"
    },
    {
      "id": "0803",
      "nombre": "Anta"
    },
    {
      "id": "0804",
      "nombre": "Calca"
    },
    {
      "id": "0805",
      "nombre": "Canas"
    },
    {
      "id": "0806",
      "nombre": "Canchis"
    },
    {
      "id": "0807",
      "nombre": "Chumbivilcas"
    },
    {
      "id": "0808",
      "nombre": "Espinar"
    },
    {
      "id": "0809",
      "nombre": "La Convencion"
    },
    {
      "id": "0810",
      "nombre": "Paruro"
    },
    {
      "id": "0811",
      "nombre": "Paucartambo"
    },
    {
      "id": "0812",
      "nombre": "Quispicanchi"
    },
    {
      "id": "0813",
      "nombre": "Urubamba"
    }
  ],
  "09": [
    {
      "id": "0901",
      "nombre": "Huancavelica"
    },
    {
      "id": "0902",
      "nombre": "Acobamba"
    },
    {
      "id": "0903",
      "nombre": "Angaraes"
    },
    {
      "id": "0904",
      "nombre": "Castrovirreyna"
    },
    {
      "id": "0905",
      "nombre": "Churcampa"
    },
    {
      "id": "0906",
      "nombre": "Huaytara"
    },
    {
      "id": "0907",
      "nombre": "Tayacaja"
    }
  ]
};

export const distritos = {
  "1001": [
    {
      "id": "100101",
      "nombre": "Huanuco"
    },
    {
      "id": "100102",
      "nombre": "Amarilis"
    },
    {
      "id": "100103",
      "nombre": "Chinchao"
    },
    {
      "id": "100104",
      "nombre": "Churubamba"
    },
    {
      "id": "100105",
      "nombre": "Margos"
    },
    {
      "id": "100106",
      "nombre": "Quisqui"
    },
    {
      "id": "100107",
      "nombre": "San Francisco de Cayran"
    },
    {
      "id": "100108",
      "nombre": "San Pedro de Chaulan"
    },
    {
      "id": "100109",
      "nombre": "Santa Maria del Valle"
    },
    {
      "id": "100110",
      "nombre": "Yarumayo"
    },
    {
      "id": "100111",
      "nombre": "Pillcomarca"
    }
  ],
  "1002": [
    {
      "id": "100201",
      "nombre": "Ambo"
    },
    {
      "id": "100202",
      "nombre": "Cayna"
    },
    {
      "id": "100203",
      "nombre": "Colpas"
    },
    {
      "id": "100204",
      "nombre": "Conchamarca"
    },
    {
      "id": "100205",
      "nombre": "Huacar"
    },
    {
      "id": "100206",
      "nombre": "San Francisco"
    },
    {
      "id": "100207",
      "nombre": "San Rafael"
    },
    {
      "id": "100208",
      "nombre": "Tomay Kichwa"
    }
  ],
  "1003": [
    {
      "id": "100301",
      "nombre": "La Union"
    },
    {
      "id": "100307",
      "nombre": "Chuquis"
    },
    {
      "id": "100311",
      "nombre": "Marias"
    },
    {
      "id": "100313",
      "nombre": "Pachas"
    },
    {
      "id": "100316",
      "nombre": "Quivilla"
    },
    {
      "id": "100317",
      "nombre": "Ripan"
    },
    {
      "id": "100321",
      "nombre": "Shunqui"
    },
    {
      "id": "100322",
      "nombre": "Sillapata"
    },
    {
      "id": "100323",
      "nombre": "Yanas"
    }
  ],
  "1004": [
    {
      "id": "100401",
      "nombre": "Huacaybamba"
    },
    {
      "id": "100402",
      "nombre": "Canchabamba"
    },
    {
      "id": "100403",
      "nombre": "Cochabamba"
    },
    {
      "id": "100404",
      "nombre": "Pinra"
    }
  ],
  "1005": [
    {
      "id": "100501",
      "nombre": "Llata"
    },
    {
      "id": "100502",
      "nombre": "Arancay"
    },
    {
      "id": "100503",
      "nombre": "Chavin de Pariarca"
    },
    {
      "id": "100504",
      "nombre": "Jacas Grande"
    },
    {
      "id": "100505",
      "nombre": "Jircan"
    },
    {
      "id": "100506",
      "nombre": "Miraflores"
    },
    {
      "id": "100507",
      "nombre": "Monzon"
    },
    {
      "id": "100508",
      "nombre": "Punchao"
    },
    {
      "id": "100509",
      "nombre": "Puqos"
    },
    {
      "id": "100510",
      "nombre": "Singa"
    },
    {
      "id": "100511",
      "nombre": "Tantamayo"
    }
  ],
  "1006": [
    {
      "id": "100601",
      "nombre": "Rupa-Rupa"
    },
    {
      "id": "100602",
      "nombre": "Daniel Alomias Robles"
    },
    {
      "id": "100603",
      "nombre": "Hermilio Valdizan"
    },
    {
      "id": "100604",
      "nombre": "Jose Crespo y Castillo"
    },
    {
      "id": "100605",
      "nombre": "Luyando"
    },
    {
      "id": "100606",
      "nombre": "Mariano Damaso Beraun"
    }
  ],
  "1007": [
    {
      "id": "100701",
      "nombre": "Huacrachuco"
    },
    {
      "id": "100702",
      "nombre": "Cholon"
    },
    {
      "id": "100703",
      "nombre": "San Buenaventura"
    }
  ],
  "1008": [
    {
      "id": "100801",
      "nombre": "Panao"
    },
    {
      "id": "100802",
      "nombre": "Chaglla"
    },
    {
      "id": "100803",
      "nombre": "Molino"
    },
    {
      "id": "100804",
      "nombre": "Umari"
    }
  ],
  "1009": [
    {
      "id": "100901",
      "nombre": "Puerto Inca"
    },
    {
      "id": "100902",
      "nombre": "Codo del Pozuzo"
    },
    {
      "id": "100903",
      "nombre": "Honoria"
    },
    {
      "id": "100904",
      "nombre": "Tournavista"
    },
    {
      "id": "100905",
      "nombre": "Yuyapichis"
    }
  ],
  "1010": [
    {
      "id": "101001",
      "nombre": "Jesus"
    },
    {
      "id": "101002",
      "nombre": "Baqos"
    },
    {
      "id": "101003",
      "nombre": "Jivia"
    },
    {
      "id": "101004",
      "nombre": "Queropalca"
    },
    {
      "id": "101005",
      "nombre": "Rondos"
    },
    {
      "id": "101006",
      "nombre": "San Francisco de Asis"
    },
    {
      "id": "101007",
      "nombre": "San Miguel de Cauri"
    }
  ],
  "1011": [
    {
      "id": "101101",
      "nombre": "Chavinillo"
    },
    {
      "id": "101102",
      "nombre": "Cahuac"
    },
    {
      "id": "101103",
      "nombre": "Chacabamba"
    },
    {
      "id": "101104",
      "nombre": "Chupan"
    },
    {
      "id": "101105",
      "nombre": "Jacas Chico"
    },
    {
      "id": "101106",
      "nombre": "Obas"
    },
    {
      "id": "101107",
      "nombre": "Pampamarca"
    },
    {
      "id": "101108",
      "nombre": "Choras"
    }
  ],
  "1101": [
    {
      "id": "110101",
      "nombre": "Ica"
    },
    {
      "id": "110102",
      "nombre": "La Tinguiqa"
    },
    {
      "id": "110103",
      "nombre": "Los Aquijes"
    },
    {
      "id": "110104",
      "nombre": "Ocucaje"
    },
    {
      "id": "110105",
      "nombre": "Pachacutec"
    },
    {
      "id": "110106",
      "nombre": "Parcona"
    },
    {
      "id": "110107",
      "nombre": "Pueblo Nuevo"
    },
    {
      "id": "110108",
      "nombre": "Salas"
    },
    {
      "id": "110109",
      "nombre": "San Jose de los Molinos"
    },
    {
      "id": "110110",
      "nombre": "San Juan Bautista"
    },
    {
      "id": "110111",
      "nombre": "Santiago"
    },
    {
      "id": "110112",
      "nombre": "Subtanjalla"
    },
    {
      "id": "110113",
      "nombre": "Tate"
    },
    {
      "id": "110114",
      "nombre": "Yauca del Rosario  1/"
    }
  ],
  "1102": [
    {
      "id": "110201",
      "nombre": "Chincha Alta"
    },
    {
      "id": "110202",
      "nombre": "Alto Laran"
    },
    {
      "id": "110203",
      "nombre": "Chavin"
    },
    {
      "id": "110204",
      "nombre": "Chincha Baja"
    },
    {
      "id": "110205",
      "nombre": "El Carmen"
    },
    {
      "id": "110206",
      "nombre": "Grocio Prado"
    },
    {
      "id": "110207",
      "nombre": "Pueblo Nuevo"
    },
    {
      "id": "110208",
      "nombre": "San Juan de Yanac"
    },
    {
      "id": "110209",
      "nombre": "San Pedro de Huacarpana"
    },
    {
      "id": "110210",
      "nombre": "Sunampe"
    },
    {
      "id": "110211",
      "nombre": "Tambo de Mora"
    }
  ],
  "1103": [
    {
      "id": "110301",
      "nombre": "Nazca"
    },
    {
      "id": "110302",
      "nombre": "Changuillo"
    },
    {
      "id": "110303",
      "nombre": "El Ingenio"
    },
    {
      "id": "110304",
      "nombre": "Marcona"
    },
    {
      "id": "110305",
      "nombre": "Vista Alegre"
    }
  ],
  "1104": [
    {
      "id": "110401",
      "nombre": "Palpa"
    },
    {
      "id": "110402",
      "nombre": "Llipata"
    },
    {
      "id": "110403",
      "nombre": "Rio Grande"
    },
    {
      "id": "110404",
      "nombre": "Santa Cruz"
    },
    {
      "id": "110405",
      "nombre": "Tibillo"
    }
  ],
  "1105": [
    {
      "id": "110501",
      "nombre": "Pisco"
    },
    {
      "id": "110502",
      "nombre": "Huancano"
    },
    {
      "id": "110503",
      "nombre": "Humay"
    },
    {
      "id": "110504",
      "nombre": "Independencia"
    },
    {
      "id": "110505",
      "nombre": "Paracas"
    },
    {
      "id": "110506",
      "nombre": "San Andres"
    },
    {
      "id": "110507",
      "nombre": "San Clemente"
    },
    {
      "id": "110508",
      "nombre": "Tupac Amaru Inca"
    }
  ],
  "1201": [
    {
      "id": "120101",
      "nombre": "Huancayo"
    },
    {
      "id": "120104",
      "nombre": "Carhuacallanga"
    },
    {
      "id": "120105",
      "nombre": "Chacapampa"
    },
    {
      "id": "120106",
      "nombre": "Chicche"
    },
    {
      "id": "120107",
      "nombre": "Chilca"
    },
    {
      "id": "120108",
      "nombre": "Chongos Alto"
    },
    {
      "id": "120111",
      "nombre": "Chupuro"
    },
    {
      "id": "120112",
      "nombre": "Colca"
    },
    {
      "id": "120113",
      "nombre": "Cullhuas"
    },
    {
      "id": "120114",
      "nombre": "El Tambo"
    },
    {
      "id": "120116",
      "nombre": "Huacrapuquio"
    },
    {
      "id": "120117",
      "nombre": "Hualhuas"
    },
    {
      "id": "120119",
      "nombre": "Huancan"
    },
    {
      "id": "120120",
      "nombre": "Huasicancha"
    },
    {
      "id": "120121",
      "nombre": "Huayucachi"
    },
    {
      "id": "120122",
      "nombre": "Ingenio"
    },
    {
      "id": "120124",
      "nombre": "Pariahuanca"
    },
    {
      "id": "120125",
      "nombre": "Pilcomayo"
    },
    {
      "id": "120126",
      "nombre": "Pucara"
    },
    {
      "id": "120127",
      "nombre": "Quichuay"
    },
    {
      "id": "120128",
      "nombre": "Quilcas"
    },
    {
      "id": "120129",
      "nombre": "San Agustin"
    },
    {
      "id": "120130",
      "nombre": "San Jeronimo de Tunan"
    },
    {
      "id": "120132",
      "nombre": "Saqo"
    },
    {
      "id": "120133",
      "nombre": "Sapallanga"
    },
    {
      "id": "120134",
      "nombre": "Sicaya"
    },
    {
      "id": "120135",
      "nombre": "Santo Domingo de Acobamba"
    },
    {
      "id": "120136",
      "nombre": "Viques"
    }
  ],
  "1202": [
    {
      "id": "120201",
      "nombre": "Concepcion"
    },
    {
      "id": "120202",
      "nombre": "Aco"
    },
    {
      "id": "120203",
      "nombre": "Andamarca"
    },
    {
      "id": "120204",
      "nombre": "Chambara"
    },
    {
      "id": "120205",
      "nombre": "Cochas"
    },
    {
      "id": "120206",
      "nombre": "Comas"
    },
    {
      "id": "120207",
      "nombre": "Heroinas Toledo"
    },
    {
      "id": "120208",
      "nombre": "Manzanares"
    },
    {
      "id": "120209",
      "nombre": "Mariscal Castilla"
    },
    {
      "id": "120210",
      "nombre": "Matahuasi"
    },
    {
      "id": "120211",
      "nombre": "Mito"
    },
    {
      "id": "120212",
      "nombre": "Nueve de Julio"
    },
    {
      "id": "120213",
      "nombre": "Orcotuna"
    },
    {
      "id": "120214",
      "nombre": "San Jose de Quero"
    },
    {
      "id": "120215",
      "nombre": "Santa Rosa de Ocopa"
    }
  ],
  "1203": [
    {
      "id": "120301",
      "nombre": "Chanchamayo"
    },
    {
      "id": "120302",
      "nombre": "Perene"
    },
    {
      "id": "120303",
      "nombre": "Pichanaqui"
    },
    {
      "id": "120304",
      "nombre": "San Luis de Shuaro"
    },
    {
      "id": "120305",
      "nombre": "San Ramon"
    },
    {
      "id": "120306",
      "nombre": "Vitoc"
    }
  ],
  "1204": [
    {
      "id": "120401",
      "nombre": "Jauja"
    },
    {
      "id": "120402",
      "nombre": "Acolla"
    },
    {
      "id": "120403",
      "nombre": "Apata"
    },
    {
      "id": "120404",
      "nombre": "Ataura"
    },
    {
      "id": "120405",
      "nombre": "Canchayllo"
    },
    {
      "id": "120406",
      "nombre": "Curicaca"
    },
    {
      "id": "120407",
      "nombre": "El Mantaro"
    },
    {
      "id": "120408",
      "nombre": "Huamali"
    },
    {
      "id": "120409",
      "nombre": "Huaripampa"
    },
    {
      "id": "120410",
      "nombre": "Huertas"
    },
    {
      "id": "120411",
      "nombre": "Janjaillo"
    },
    {
      "id": "120412",
      "nombre": "Julcan"
    },
    {
      "id": "120413",
      "nombre": "Leonor Ordoqez"
    },
    {
      "id": "120414",
      "nombre": "Llocllapampa"
    },
    {
      "id": "120415",
      "nombre": "Marco"
    },
    {
      "id": "120416",
      "nombre": "Masma"
    },
    {
      "id": "120417",
      "nombre": "Masma Chicche"
    },
    {
      "id": "120418",
      "nombre": "Molinos"
    },
    {
      "id": "120419",
      "nombre": "Monobamba"
    },
    {
      "id": "120420",
      "nombre": "Muqui"
    },
    {
      "id": "120421",
      "nombre": "Muquiyauyo"
    },
    {
      "id": "120422",
      "nombre": "Paca"
    },
    {
      "id": "120423",
      "nombre": "Paccha"
    },
    {
      "id": "120424",
      "nombre": "Pancan"
    },
    {
      "id": "120425",
      "nombre": "Parco"
    },
    {
      "id": "120426",
      "nombre": "Pomacancha"
    },
    {
      "id": "120427",
      "nombre": "Ricran"
    },
    {
      "id": "120428",
      "nombre": "San Lorenzo"
    },
    {
      "id": "120429",
      "nombre": "San Pedro de Chunan"
    },
    {
      "id": "120430",
      "nombre": "Sausa"
    },
    {
      "id": "120431",
      "nombre": "Sincos"
    },
    {
      "id": "120432",
      "nombre": "Tunan Marca"
    },
    {
      "id": "120433",
      "nombre": "Yauli"
    },
    {
      "id": "120434",
      "nombre": "Yauyos"
    }
  ],
  "1205": [
    {
      "id": "120501",
      "nombre": "Junin"
    },
    {
      "id": "120502",
      "nombre": "Carhuamayo"
    },
    {
      "id": "120503",
      "nombre": "Ondores"
    },
    {
      "id": "120504",
      "nombre": "Ulcumayo"
    }
  ],
  "1206": [
    {
      "id": "120601",
      "nombre": "Satipo"
    },
    {
      "id": "120602",
      "nombre": "Coviriali"
    },
    {
      "id": "120603",
      "nombre": "Llaylla"
    },
    {
      "id": "120604",
      "nombre": "Mazamari"
    },
    {
      "id": "120605",
      "nombre": "Pampa Hermosa"
    },
    {
      "id": "120606",
      "nombre": "Pangoa"
    },
    {
      "id": "120607",
      "nombre": "Rio Negro"
    },
    {
      "id": "120608",
      "nombre": "Rio Tambo"
    }
  ],
  "1207": [
    {
      "id": "120701",
      "nombre": "Tarma"
    },
    {
      "id": "120702",
      "nombre": "Acobamba"
    },
    {
      "id": "120703",
      "nombre": "Huaricolca"
    },
    {
      "id": "120704",
      "nombre": "Huasahuasi"
    },
    {
      "id": "120705",
      "nombre": "La Union"
    },
    {
      "id": "120706",
      "nombre": "Palca"
    },
    {
      "id": "120707",
      "nombre": "Palcamayo"
    },
    {
      "id": "120708",
      "nombre": "San Pedro de Cajas"
    },
    {
      "id": "120709",
      "nombre": "Tapo"
    }
  ],
  "1208": [
    {
      "id": "120801",
      "nombre": "La Oroya"
    },
    {
      "id": "120802",
      "nombre": "Chacapalpa"
    },
    {
      "id": "120803",
      "nombre": "Huay-Huay"
    },
    {
      "id": "120804",
      "nombre": "Marcapomacocha"
    },
    {
      "id": "120805",
      "nombre": "Morococha"
    },
    {
      "id": "120806",
      "nombre": "Paccha"
    },
    {
      "id": "120807",
      "nombre": "Santa Barbara de Carhuacayan"
    },
    {
      "id": "120808",
      "nombre": "Santa Rosa de Sacco"
    },
    {
      "id": "120809",
      "nombre": "Suitucancha"
    },
    {
      "id": "120810",
      "nombre": "Yauli"
    }
  ],
  "1209": [
    {
      "id": "120901",
      "nombre": "Chupaca"
    },
    {
      "id": "120902",
      "nombre": "Ahuac"
    },
    {
      "id": "120903",
      "nombre": "Chongos Bajo"
    },
    {
      "id": "120904",
      "nombre": "Huachac"
    },
    {
      "id": "120905",
      "nombre": "Huamancaca Chico"
    },
    {
      "id": "120906",
      "nombre": "San Juan de Iscos"
    },
    {
      "id": "120907",
      "nombre": "San Juan de Jarpa"
    },
    {
      "id": "120908",
      "nombre": "Tres de Diciembre"
    },
    {
      "id": "120909",
      "nombre": "Yanacancha"
    }
  ],
  "1301": [
    {
      "id": "130101",
      "nombre": "Trujillo"
    },
    {
      "id": "130102",
      "nombre": "El Porvenir"
    },
    {
      "id": "130103",
      "nombre": "Florencia de Mora"
    },
    {
      "id": "130104",
      "nombre": "Huanchaco"
    },
    {
      "id": "130105",
      "nombre": "La Esperanza"
    },
    {
      "id": "130106",
      "nombre": "Laredo"
    },
    {
      "id": "130107",
      "nombre": "Moche"
    },
    {
      "id": "130108",
      "nombre": "Poroto"
    },
    {
      "id": "130109",
      "nombre": "Salaverry"
    },
    {
      "id": "130110",
      "nombre": "Simbal"
    },
    {
      "id": "130111",
      "nombre": "Victor Larco Herrera"
    }
  ],
  "1302": [
    {
      "id": "130201",
      "nombre": "Ascope"
    },
    {
      "id": "130202",
      "nombre": "Chicama"
    },
    {
      "id": "130203",
      "nombre": "Chocope"
    },
    {
      "id": "130204",
      "nombre": "Magdalena de Cao"
    },
    {
      "id": "130205",
      "nombre": "Paijan"
    },
    {
      "id": "130206",
      "nombre": "Razuri"
    },
    {
      "id": "130207",
      "nombre": "Santiago de Cao"
    },
    {
      "id": "130208",
      "nombre": "Casa Grande"
    }
  ],
  "1303": [
    {
      "id": "130301",
      "nombre": "Bolivar"
    },
    {
      "id": "130302",
      "nombre": "Bambamarca"
    },
    {
      "id": "130303",
      "nombre": "Condormarca"
    },
    {
      "id": "130304",
      "nombre": "Longotea"
    },
    {
      "id": "130305",
      "nombre": "Uchumarca"
    },
    {
      "id": "130306",
      "nombre": "Ucuncha"
    }
  ],
  "1304": [
    {
      "id": "130401",
      "nombre": "Chepen"
    },
    {
      "id": "130402",
      "nombre": "Pacanga"
    },
    {
      "id": "130403",
      "nombre": "Pueblo Nuevo"
    }
  ],
  "1305": [
    {
      "id": "130501",
      "nombre": "Julcan"
    },
    {
      "id": "130502",
      "nombre": "Calamarca"
    },
    {
      "id": "130503",
      "nombre": "Carabamba"
    },
    {
      "id": "130504",
      "nombre": "Huaso"
    }
  ],
  "1306": [
    {
      "id": "130601",
      "nombre": "Otuzco"
    },
    {
      "id": "130602",
      "nombre": "Agallpampa"
    },
    {
      "id": "130604",
      "nombre": "Charat"
    },
    {
      "id": "130605",
      "nombre": "Huaranchal"
    },
    {
      "id": "130606",
      "nombre": "La Cuesta"
    },
    {
      "id": "130608",
      "nombre": "Mache"
    },
    {
      "id": "130610",
      "nombre": "Paranday"
    },
    {
      "id": "130611",
      "nombre": "Salpo"
    },
    {
      "id": "130613",
      "nombre": "Sinsicap"
    },
    {
      "id": "130614",
      "nombre": "Usquil"
    }
  ],
  "1307": [
    {
      "id": "130701",
      "nombre": "San Pedro de Lloc"
    },
    {
      "id": "130702",
      "nombre": "Guadalupe"
    },
    {
      "id": "130703",
      "nombre": "Jequetepeque"
    },
    {
      "id": "130704",
      "nombre": "Pacasmayo"
    },
    {
      "id": "130705",
      "nombre": "San Jose"
    }
  ],
  "1308": [
    {
      "id": "130801",
      "nombre": "Tayabamba"
    },
    {
      "id": "130802",
      "nombre": "Buldibuyo"
    },
    {
      "id": "130803",
      "nombre": "Chillia"
    },
    {
      "id": "130804",
      "nombre": "Huancaspata"
    },
    {
      "id": "130805",
      "nombre": "Huaylillas"
    },
    {
      "id": "130806",
      "nombre": "Huayo"
    },
    {
      "id": "130807",
      "nombre": "Ongon"
    },
    {
      "id": "130808",
      "nombre": "Parcoy"
    },
    {
      "id": "130809",
      "nombre": "Pataz"
    },
    {
      "id": "130810",
      "nombre": "Pias"
    },
    {
      "id": "130811",
      "nombre": "Santiago de Challas"
    },
    {
      "id": "130812",
      "nombre": "Taurija"
    },
    {
      "id": "130813",
      "nombre": "Urpay"
    }
  ],
  "1309": [
    {
      "id": "130901",
      "nombre": "Huamachuco"
    },
    {
      "id": "130902",
      "nombre": "Chugay"
    },
    {
      "id": "130903",
      "nombre": "Cochorco"
    },
    {
      "id": "130904",
      "nombre": "Curgos"
    },
    {
      "id": "130905",
      "nombre": "Marcabal"
    },
    {
      "id": "130906",
      "nombre": "Sanagoran"
    },
    {
      "id": "130907",
      "nombre": "Sarin"
    },
    {
      "id": "130908",
      "nombre": "Sartimbamba"
    }
  ],
  "1310": [
    {
      "id": "131001",
      "nombre": "Santiago de Chuco"
    },
    {
      "id": "131002",
      "nombre": "Angasmarca"
    },
    {
      "id": "131003",
      "nombre": "Cachicadan"
    },
    {
      "id": "131004",
      "nombre": "Mollebamba"
    },
    {
      "id": "131005",
      "nombre": "Mollepata"
    },
    {
      "id": "131006",
      "nombre": "Quiruvilca"
    },
    {
      "id": "131007",
      "nombre": "Santa Cruz de Chuca"
    },
    {
      "id": "131008",
      "nombre": "Sitabamba"
    }
  ],
  "1311": [
    {
      "id": "131101",
      "nombre": "Cascas"
    },
    {
      "id": "131102",
      "nombre": "Lucma"
    },
    {
      "id": "131103",
      "nombre": "Marmot"
    },
    {
      "id": "131104",
      "nombre": "Sayapullo"
    }
  ],
  "1312": [
    {
      "id": "131201",
      "nombre": "Viru"
    },
    {
      "id": "131202",
      "nombre": "Chao"
    },
    {
      "id": "131203",
      "nombre": "Guadalupito"
    }
  ],
  "1401": [
    {
      "id": "140101",
      "nombre": "Chiclayo"
    },
    {
      "id": "140102",
      "nombre": "Chongoyape"
    },
    {
      "id": "140103",
      "nombre": "Eten"
    },
    {
      "id": "140104",
      "nombre": "Eten Puerto"
    },
    {
      "id": "140105",
      "nombre": "Jose Leonardo Ortiz"
    },
    {
      "id": "140106",
      "nombre": "La Victoria"
    },
    {
      "id": "140107",
      "nombre": "Lagunas"
    },
    {
      "id": "140108",
      "nombre": "Monsefu"
    },
    {
      "id": "140109",
      "nombre": "Nueva Arica"
    },
    {
      "id": "140110",
      "nombre": "Oyotun"
    },
    {
      "id": "140111",
      "nombre": "Picsi"
    },
    {
      "id": "140112",
      "nombre": "Pimentel"
    },
    {
      "id": "140113",
      "nombre": "Reque"
    },
    {
      "id": "140114",
      "nombre": "Santa Rosa"
    },
    {
      "id": "140115",
      "nombre": "Saqa"
    },
    {
      "id": "140116",
      "nombre": "Cayaltí"
    },
    {
      "id": "140117",
      "nombre": "Patapo"
    },
    {
      "id": "140118",
      "nombre": "Pomalca"
    },
    {
      "id": "140119",
      "nombre": "Pucalá"
    },
    {
      "id": "140120",
      "nombre": "Tumán"
    }
  ],
  "1402": [
    {
      "id": "140201",
      "nombre": "Ferreqafe"
    },
    {
      "id": "140202",
      "nombre": "Caqaris"
    },
    {
      "id": "140203",
      "nombre": "Incahuasi"
    },
    {
      "id": "140204",
      "nombre": "Manuel Antonio Mesones Muro"
    },
    {
      "id": "140205",
      "nombre": "Pitipo"
    },
    {
      "id": "140206",
      "nombre": "Pueblo Nuevo"
    }
  ],
  "1403": [
    {
      "id": "140301",
      "nombre": "Lambayeque"
    },
    {
      "id": "140302",
      "nombre": "Chochope"
    },
    {
      "id": "140303",
      "nombre": "Illimo"
    },
    {
      "id": "140304",
      "nombre": "Jayanca"
    },
    {
      "id": "140305",
      "nombre": "Mochumi"
    },
    {
      "id": "140306",
      "nombre": "Morrope"
    },
    {
      "id": "140307",
      "nombre": "Motupe"
    },
    {
      "id": "140308",
      "nombre": "Olmos"
    },
    {
      "id": "140309",
      "nombre": "Pacora"
    },
    {
      "id": "140310",
      "nombre": "Salas"
    },
    {
      "id": "140311",
      "nombre": "San Jose"
    },
    {
      "id": "140312",
      "nombre": "Tucume"
    }
  ],
  "1501": [
    {
      "id": "150101",
      "nombre": "Cercado de Lima"
    },
    {
      "id": "150102",
      "nombre": "Ancon"
    },
    {
      "id": "150103",
      "nombre": "Ate"
    },
    {
      "id": "150104",
      "nombre": "Barranco"
    },
    {
      "id": "150105",
      "nombre": "Breña"
    },
    {
      "id": "150106",
      "nombre": "Carabayllo"
    },
    {
      "id": "150107",
      "nombre": "Chaclacayo"
    },
    {
      "id": "150108",
      "nombre": "Chorrillos"
    },
    {
      "id": "150109",
      "nombre": "Cieneguilla"
    },
    {
      "id": "150110",
      "nombre": "Comas"
    },
    {
      "id": "150111",
      "nombre": "El Agustino"
    },
    {
      "id": "150112",
      "nombre": "Independencia"
    },
    {
      "id": "150113",
      "nombre": "Jesus Maria"
    },
    {
      "id": "150114",
      "nombre": "La Molina"
    },
    {
      "id": "150115",
      "nombre": "La Victoria"
    },
    {
      "id": "150116",
      "nombre": "Lince"
    },
    {
      "id": "150117",
      "nombre": "Los Olivos"
    },
    {
      "id": "150118",
      "nombre": "Lurigancho"
    },
    {
      "id": "150119",
      "nombre": "Lurin"
    },
    {
      "id": "150120",
      "nombre": "Magdalena del Mar"
    },
    {
      "id": "150121",
      "nombre": "Pueblo Libre"
    },
    {
      "id": "150122",
      "nombre": "Miraflores"
    },
    {
      "id": "150123",
      "nombre": "Pachacamac"
    },
    {
      "id": "150124",
      "nombre": "Pucusana"
    },
    {
      "id": "150125",
      "nombre": "Puente Piedra"
    },
    {
      "id": "150126",
      "nombre": "Punta Hermosa"
    },
    {
      "id": "150127",
      "nombre": "Punta Negra"
    },
    {
      "id": "150128",
      "nombre": "Rimac"
    },
    {
      "id": "150129",
      "nombre": "San Bartolo"
    },
    {
      "id": "150130",
      "nombre": "San Borja"
    },
    {
      "id": "150131",
      "nombre": "San Isidro"
    },
    {
      "id": "150132",
      "nombre": "San Juan de Lurigancho"
    },
    {
      "id": "150133",
      "nombre": "San Juan de Miraflores"
    },
    {
      "id": "150134",
      "nombre": "San Luis"
    },
    {
      "id": "150135",
      "nombre": "San Martin de Porres"
    },
    {
      "id": "150136",
      "nombre": "San Miguel"
    },
    {
      "id": "150137",
      "nombre": "Santa Anita"
    },
    {
      "id": "150138",
      "nombre": "Santa Maria del Mar"
    },
    {
      "id": "150139",
      "nombre": "Santa Rosa"
    },
    {
      "id": "150140",
      "nombre": "Santiago de Surco"
    },
    {
      "id": "150141",
      "nombre": "Surquillo"
    },
    {
      "id": "150142",
      "nombre": "Villa El Salvador"
    },
    {
      "id": "150143",
      "nombre": "Villa Maria del Triunfo"
    }
  ],
  "1502": [
    {
      "id": "150201",
      "nombre": "Barranca"
    },
    {
      "id": "150202",
      "nombre": "Paramonga"
    },
    {
      "id": "150203",
      "nombre": "Pativilca"
    },
    {
      "id": "150204",
      "nombre": "Supe"
    },
    {
      "id": "150205",
      "nombre": "Supe Puerto"
    }
  ],
  "1503": [
    {
      "id": "150301",
      "nombre": "Cajatambo"
    },
    {
      "id": "150302",
      "nombre": "Copa"
    },
    {
      "id": "150303",
      "nombre": "Gorgor"
    },
    {
      "id": "150304",
      "nombre": "Huancapon"
    },
    {
      "id": "150305",
      "nombre": "Manas"
    }
  ],
  "1504": [
    {
      "id": "150401",
      "nombre": "Canta"
    },
    {
      "id": "150402",
      "nombre": "Arahuay"
    },
    {
      "id": "150403",
      "nombre": "Huamantanga"
    },
    {
      "id": "150404",
      "nombre": "Huaros"
    },
    {
      "id": "150405",
      "nombre": "Lachaqui"
    },
    {
      "id": "150406",
      "nombre": "San Buenaventura"
    },
    {
      "id": "150407",
      "nombre": "Santa Rosa de Quives"
    }
  ],
  "1505": [
    {
      "id": "150501",
      "nombre": "San Vicente de Cañete"
    },
    {
      "id": "150502",
      "nombre": "Asia"
    },
    {
      "id": "150503",
      "nombre": "Calango"
    },
    {
      "id": "150504",
      "nombre": "Cerro Azul"
    },
    {
      "id": "150505",
      "nombre": "Chilca"
    },
    {
      "id": "150506",
      "nombre": "Coayllo"
    },
    {
      "id": "150507",
      "nombre": "Imperial"
    },
    {
      "id": "150508",
      "nombre": "Lunahuana"
    },
    {
      "id": "150509",
      "nombre": "Mala"
    },
    {
      "id": "150510",
      "nombre": "Nuevo Imperial"
    },
    {
      "id": "150511",
      "nombre": "Pacaran"
    },
    {
      "id": "150512",
      "nombre": "Quilmana"
    },
    {
      "id": "150513",
      "nombre": "San Antonio"
    },
    {
      "id": "150514",
      "nombre": "San Luis"
    },
    {
      "id": "150515",
      "nombre": "Santa Cruz de Flores"
    },
    {
      "id": "150516",
      "nombre": "Zuqiga"
    }
  ],
  "1506": [
    {
      "id": "150601",
      "nombre": "Huaral"
    },
    {
      "id": "150602",
      "nombre": "Atavillos Alto"
    },
    {
      "id": "150603",
      "nombre": "Atavillos Bajo"
    },
    {
      "id": "150604",
      "nombre": "Aucallama"
    },
    {
      "id": "150605",
      "nombre": "Chancay"
    },
    {
      "id": "150606",
      "nombre": "Ihuari"
    },
    {
      "id": "150607",
      "nombre": "Lampian"
    },
    {
      "id": "150608",
      "nombre": "Pacaraos"
    },
    {
      "id": "150609",
      "nombre": "San Miguel de Acos"
    },
    {
      "id": "150610",
      "nombre": "Santa Cruz de Andamarca"
    },
    {
      "id": "150611",
      "nombre": "Sumbilca"
    },
    {
      "id": "150612",
      "nombre": "Veintisiete de Noviembre"
    }
  ],
  "1507": [
    {
      "id": "150701",
      "nombre": "Matucana"
    },
    {
      "id": "150702",
      "nombre": "Antioquia"
    },
    {
      "id": "150703",
      "nombre": "Callahuanca"
    },
    {
      "id": "150704",
      "nombre": "Carampoma"
    },
    {
      "id": "150705",
      "nombre": "Chicla"
    },
    {
      "id": "150706",
      "nombre": "Cuenca"
    },
    {
      "id": "150707",
      "nombre": "Huachupampa"
    },
    {
      "id": "150708",
      "nombre": "Huanza"
    },
    {
      "id": "150709",
      "nombre": "Huarochiri"
    },
    {
      "id": "150710",
      "nombre": "Lahuaytambo"
    },
    {
      "id": "150711",
      "nombre": "Langa"
    },
    {
      "id": "150712",
      "nombre": "Laraos"
    },
    {
      "id": "150713",
      "nombre": "Mariatana"
    },
    {
      "id": "150714",
      "nombre": "Ricardo Palma"
    },
    {
      "id": "150715",
      "nombre": "San Andres de Tupicocha"
    },
    {
      "id": "150716",
      "nombre": "San Antonio"
    },
    {
      "id": "150717",
      "nombre": "San Bartolome"
    },
    {
      "id": "150718",
      "nombre": "San Damian"
    },
    {
      "id": "150719",
      "nombre": "San Juan de Iris"
    },
    {
      "id": "150720",
      "nombre": "San Juan de Tantaranche"
    },
    {
      "id": "150721",
      "nombre": "San Lorenzo de Quinti"
    },
    {
      "id": "150722",
      "nombre": "San Mateo"
    },
    {
      "id": "150723",
      "nombre": "San Mateo de Otao"
    },
    {
      "id": "150724",
      "nombre": "San Pedro de Casta"
    },
    {
      "id": "150725",
      "nombre": "San Pedro de Huancayre"
    },
    {
      "id": "150726",
      "nombre": "Sangallaya"
    },
    {
      "id": "150727",
      "nombre": "Santa Cruz de Cocachacra"
    },
    {
      "id": "150728",
      "nombre": "Santa Eulalia"
    },
    {
      "id": "150729",
      "nombre": "Santiago de Anchucaya"
    },
    {
      "id": "150730",
      "nombre": "Santiago de Tuna"
    },
    {
      "id": "150731",
      "nombre": "Santo Domingo de los Olleros"
    },
    {
      "id": "150732",
      "nombre": "Surco"
    }
  ],
  "1508": [
    {
      "id": "150801",
      "nombre": "Huacho"
    },
    {
      "id": "150802",
      "nombre": "Ambar"
    },
    {
      "id": "150803",
      "nombre": "Caleta de Carquin"
    },
    {
      "id": "150804",
      "nombre": "Checras"
    },
    {
      "id": "150805",
      "nombre": "Hualmay"
    },
    {
      "id": "150806",
      "nombre": "Huaura"
    },
    {
      "id": "150807",
      "nombre": "Leoncio Prado"
    },
    {
      "id": "150808",
      "nombre": "Paccho"
    },
    {
      "id": "150809",
      "nombre": "Santa Leonor"
    },
    {
      "id": "150810",
      "nombre": "Santa Maria"
    },
    {
      "id": "150811",
      "nombre": "Sayan"
    },
    {
      "id": "150812",
      "nombre": "Vegueta"
    }
  ],
  "1509": [
    {
      "id": "150901",
      "nombre": "Oyon"
    },
    {
      "id": "150902",
      "nombre": "Andajes"
    },
    {
      "id": "150903",
      "nombre": "Caujul"
    },
    {
      "id": "150904",
      "nombre": "Cochamarca"
    },
    {
      "id": "150905",
      "nombre": "Navan"
    },
    {
      "id": "150906",
      "nombre": "Pachangara"
    }
  ],
  "1510": [
    {
      "id": "151001",
      "nombre": "Yauyos"
    },
    {
      "id": "151002",
      "nombre": "Alis"
    },
    {
      "id": "151003",
      "nombre": "Ayauca"
    },
    {
      "id": "151004",
      "nombre": "Ayaviri"
    },
    {
      "id": "151005",
      "nombre": "Azangaro"
    },
    {
      "id": "151006",
      "nombre": "Cacra"
    },
    {
      "id": "151007",
      "nombre": "Carania"
    },
    {
      "id": "151008",
      "nombre": "Catahuasi"
    },
    {
      "id": "151009",
      "nombre": "Chocos"
    },
    {
      "id": "151010",
      "nombre": "Cochas"
    },
    {
      "id": "151011",
      "nombre": "Colonia"
    },
    {
      "id": "151012",
      "nombre": "Hongos"
    },
    {
      "id": "151013",
      "nombre": "Huampara"
    },
    {
      "id": "151014",
      "nombre": "Huancaya"
    },
    {
      "id": "151015",
      "nombre": "Huangascar"
    },
    {
      "id": "151016",
      "nombre": "Huantan"
    },
    {
      "id": "151017",
      "nombre": "Huaqec"
    },
    {
      "id": "151018",
      "nombre": "Laraos"
    },
    {
      "id": "151019",
      "nombre": "Lincha"
    },
    {
      "id": "151020",
      "nombre": "Madean"
    },
    {
      "id": "151021",
      "nombre": "Miraflores"
    },
    {
      "id": "151022",
      "nombre": "Omas"
    },
    {
      "id": "151023",
      "nombre": "Putinza"
    },
    {
      "id": "151024",
      "nombre": "Quinches"
    },
    {
      "id": "151025",
      "nombre": "Quinocay"
    },
    {
      "id": "151026",
      "nombre": "San Joaquin"
    },
    {
      "id": "151027",
      "nombre": "San Pedro de Pilas"
    },
    {
      "id": "151028",
      "nombre": "Tanta"
    },
    {
      "id": "151029",
      "nombre": "Tauripampa"
    },
    {
      "id": "151030",
      "nombre": "Tomas"
    },
    {
      "id": "151031",
      "nombre": "Tupe"
    },
    {
      "id": "151032",
      "nombre": "Viqac"
    },
    {
      "id": "151033",
      "nombre": "Vitis"
    }
  ],
  "1601": [
    {
      "id": "160101",
      "nombre": "Iquitos"
    },
    {
      "id": "160102",
      "nombre": "Alto Nanay"
    },
    {
      "id": "160103",
      "nombre": "Fernando Lores"
    },
    {
      "id": "160104",
      "nombre": "Indiana"
    },
    {
      "id": "160105",
      "nombre": "Las Amazonas"
    },
    {
      "id": "160106",
      "nombre": "Mazan"
    },
    {
      "id": "160107",
      "nombre": "Napo"
    },
    {
      "id": "160108",
      "nombre": "Punchana"
    },
    {
      "id": "160109",
      "nombre": "Putumayo"
    },
    {
      "id": "160110",
      "nombre": "Torres Causana"
    },
    {
      "id": "160111",
      "nombre": "Yaquerana"
    },
    {
      "id": "160112",
      "nombre": "Belén"
    },
    {
      "id": "160113",
      "nombre": "San Juan Bautista"
    }
  ],
  "1602": [
    {
      "id": "160201",
      "nombre": "Yurimaguas"
    },
    {
      "id": "160202",
      "nombre": "Balsapuerto"
    },
    {
      "id": "160203",
      "nombre": "Barranca"
    },
    {
      "id": "160204",
      "nombre": "Cahuapanas"
    },
    {
      "id": "160205",
      "nombre": "Jeberos"
    },
    {
      "id": "160206",
      "nombre": "Lagunas"
    },
    {
      "id": "160207",
      "nombre": "Manseriche"
    },
    {
      "id": "160208",
      "nombre": "Morona"
    },
    {
      "id": "160209",
      "nombre": "Pastaza"
    },
    {
      "id": "160210",
      "nombre": "Santa Cruz"
    },
    {
      "id": "160211",
      "nombre": "Teniente Cesar Lopez Rojas"
    }
  ],
  "1603": [
    {
      "id": "160301",
      "nombre": "Nauta"
    },
    {
      "id": "160302",
      "nombre": "Parinari"
    },
    {
      "id": "160303",
      "nombre": "Tigre"
    },
    {
      "id": "160304",
      "nombre": "Trompeteros"
    },
    {
      "id": "160305",
      "nombre": "Urarinas"
    }
  ],
  "1604": [
    {
      "id": "160401",
      "nombre": "Ramon Castilla"
    },
    {
      "id": "160402",
      "nombre": "Pebas"
    },
    {
      "id": "160403",
      "nombre": "Yavari"
    },
    {
      "id": "160404",
      "nombre": "San Pablo"
    }
  ],
  "1605": [
    {
      "id": "160501",
      "nombre": "Requena"
    },
    {
      "id": "160502",
      "nombre": "Alto Tapiche"
    },
    {
      "id": "160503",
      "nombre": "Capelo"
    },
    {
      "id": "160504",
      "nombre": "Emilio San Martin"
    },
    {
      "id": "160505",
      "nombre": "Maquia"
    },
    {
      "id": "160506",
      "nombre": "Puinahua"
    },
    {
      "id": "160507",
      "nombre": "Saquena"
    },
    {
      "id": "160508",
      "nombre": "Soplin"
    },
    {
      "id": "160509",
      "nombre": "Tapiche"
    },
    {
      "id": "160510",
      "nombre": "Jenaro Herrera"
    },
    {
      "id": "160511",
      "nombre": "Yaquerana"
    }
  ],
  "1606": [
    {
      "id": "160601",
      "nombre": "Contamana"
    },
    {
      "id": "160602",
      "nombre": "Inahuaya"
    },
    {
      "id": "160603",
      "nombre": "Padre Marquez"
    },
    {
      "id": "160604",
      "nombre": "Pampa Hermosa"
    },
    {
      "id": "160605",
      "nombre": "Sarayacu"
    },
    {
      "id": "160606",
      "nombre": "Vargas Guerra"
    }
  ],
  "1701": [
    {
      "id": "170101",
      "nombre": "Tambopata"
    },
    {
      "id": "170102",
      "nombre": "Inambari"
    },
    {
      "id": "170103",
      "nombre": "Las Piedras"
    },
    {
      "id": "170104",
      "nombre": "Laberinto"
    }
  ],
  "1702": [
    {
      "id": "170201",
      "nombre": "Manu"
    },
    {
      "id": "170202",
      "nombre": "Fitzcarrald"
    },
    {
      "id": "170203",
      "nombre": "Madre de Dios"
    },
    {
      "id": "170204",
      "nombre": "Huepetuhe"
    }
  ],
  "1703": [
    {
      "id": "170301",
      "nombre": "Iqapari"
    },
    {
      "id": "170302",
      "nombre": "Iberia"
    },
    {
      "id": "170303",
      "nombre": "Tahuamanu"
    }
  ],
  "1801": [
    {
      "id": "180101",
      "nombre": "Moquegua"
    },
    {
      "id": "180102",
      "nombre": "Carumas"
    },
    {
      "id": "180103",
      "nombre": "Cuchumbaya"
    },
    {
      "id": "180104",
      "nombre": "Samegua"
    },
    {
      "id": "180105",
      "nombre": "San Cristobal"
    },
    {
      "id": "180106",
      "nombre": "Torata"
    }
  ],
  "1802": [
    {
      "id": "180201",
      "nombre": "Omate"
    },
    {
      "id": "180202",
      "nombre": "Chojata"
    },
    {
      "id": "180203",
      "nombre": "Coalaque"
    },
    {
      "id": "180204",
      "nombre": "Ichuqa"
    },
    {
      "id": "180205",
      "nombre": "La Capilla"
    },
    {
      "id": "180206",
      "nombre": "Lloque"
    },
    {
      "id": "180207",
      "nombre": "Matalaque"
    },
    {
      "id": "180208",
      "nombre": "Puquina"
    },
    {
      "id": "180209",
      "nombre": "Quinistaquillas"
    },
    {
      "id": "180210",
      "nombre": "Ubinas"
    },
    {
      "id": "180211",
      "nombre": "Yunga"
    }
  ],
  "1803": [
    {
      "id": "180301",
      "nombre": "Ilo"
    },
    {
      "id": "180302",
      "nombre": "El Algarrobal"
    },
    {
      "id": "180303",
      "nombre": "Pacocha"
    }
  ],
  "1901": [
    {
      "id": "190101",
      "nombre": "Chaupimarca"
    },
    {
      "id": "190102",
      "nombre": "Huachon"
    },
    {
      "id": "190103",
      "nombre": "Huariaca"
    },
    {
      "id": "190104",
      "nombre": "Huayllay"
    },
    {
      "id": "190105",
      "nombre": "Ninacaca"
    },
    {
      "id": "190106",
      "nombre": "Pallanchacra"
    },
    {
      "id": "190107",
      "nombre": "Paucartambo"
    },
    {
      "id": "190108",
      "nombre": "San Fco.De Asis de Yarusyacan"
    },
    {
      "id": "190109",
      "nombre": "Simon Bolivar"
    },
    {
      "id": "190110",
      "nombre": "Ticlacayan"
    },
    {
      "id": "190111",
      "nombre": "Tinyahuarco"
    },
    {
      "id": "190112",
      "nombre": "Vicco"
    },
    {
      "id": "190113",
      "nombre": "Yanacancha"
    }
  ],
  "1902": [
    {
      "id": "190201",
      "nombre": "Yanahuanca"
    },
    {
      "id": "190202",
      "nombre": "Chacayan"
    },
    {
      "id": "190203",
      "nombre": "Goyllarisquizga"
    },
    {
      "id": "190204",
      "nombre": "Paucar"
    },
    {
      "id": "190205",
      "nombre": "San Pedro de Pillao"
    },
    {
      "id": "190206",
      "nombre": "Santa Ana de Tusi"
    },
    {
      "id": "190207",
      "nombre": "Tapuc"
    },
    {
      "id": "190208",
      "nombre": "Vilcabamba"
    }
  ],
  "1903": [
    {
      "id": "190301",
      "nombre": "Oxapampa"
    },
    {
      "id": "190302",
      "nombre": "Chontabamba"
    },
    {
      "id": "190303",
      "nombre": "Huancabamba"
    },
    {
      "id": "190304",
      "nombre": "Palcazu"
    },
    {
      "id": "190305",
      "nombre": "Pozuzo"
    },
    {
      "id": "190306",
      "nombre": "Puerto Bermudez"
    },
    {
      "id": "190307",
      "nombre": "Villa Rica"
    }
  ],
  "2001": [
    {
      "id": "200101",
      "nombre": "Piura"
    },
    {
      "id": "200104",
      "nombre": "Castilla"
    },
    {
      "id": "200105",
      "nombre": "Catacaos"
    },
    {
      "id": "200107",
      "nombre": "Cura Mori"
    },
    {
      "id": "200108",
      "nombre": "El Tallan"
    },
    {
      "id": "200109",
      "nombre": "La Arena"
    },
    {
      "id": "200110",
      "nombre": "La Union"
    },
    {
      "id": "200111",
      "nombre": "Las Lomas"
    },
    {
      "id": "200114",
      "nombre": "Tambo Grande"
    }
  ],
  "2002": [
    {
      "id": "200201",
      "nombre": "Ayabaca"
    },
    {
      "id": "200202",
      "nombre": "Frias"
    },
    {
      "id": "200203",
      "nombre": "Jilili"
    },
    {
      "id": "200204",
      "nombre": "Lagunas"
    },
    {
      "id": "200205",
      "nombre": "Montero"
    },
    {
      "id": "200206",
      "nombre": "Pacaipampa"
    },
    {
      "id": "200207",
      "nombre": "Paimas"
    },
    {
      "id": "200208",
      "nombre": "Sapillica"
    },
    {
      "id": "200209",
      "nombre": "Sicchez"
    },
    {
      "id": "200210",
      "nombre": "Suyo"
    }
  ],
  "2003": [
    {
      "id": "200301",
      "nombre": "Huancabamba"
    },
    {
      "id": "200302",
      "nombre": "Canchaque"
    },
    {
      "id": "200303",
      "nombre": "El Carmen de la Frontera"
    },
    {
      "id": "200304",
      "nombre": "Huarmaca"
    },
    {
      "id": "200305",
      "nombre": "Lalaquiz"
    },
    {
      "id": "200306",
      "nombre": "San Miguel de El Faique"
    },
    {
      "id": "200307",
      "nombre": "Sondor"
    },
    {
      "id": "200308",
      "nombre": "Sondorillo"
    }
  ],
  "2004": [
    {
      "id": "200401",
      "nombre": "Chulucanas"
    },
    {
      "id": "200402",
      "nombre": "Buenos Aires"
    },
    {
      "id": "200403",
      "nombre": "Chalaco"
    },
    {
      "id": "200404",
      "nombre": "La Matanza"
    },
    {
      "id": "200405",
      "nombre": "Morropon"
    },
    {
      "id": "200406",
      "nombre": "Salitral"
    },
    {
      "id": "200407",
      "nombre": "San Juan de Bigote"
    },
    {
      "id": "200408",
      "nombre": "Santa Catalina de Mossa"
    },
    {
      "id": "200409",
      "nombre": "Santo Domingo"
    },
    {
      "id": "200410",
      "nombre": "Yamango"
    }
  ],
  "2005": [
    {
      "id": "200501",
      "nombre": "Paita"
    },
    {
      "id": "200502",
      "nombre": "Amotape"
    },
    {
      "id": "200503",
      "nombre": "Arenal"
    },
    {
      "id": "200504",
      "nombre": "Colan"
    },
    {
      "id": "200505",
      "nombre": "La Huaca"
    },
    {
      "id": "200506",
      "nombre": "Tamarindo"
    },
    {
      "id": "200507",
      "nombre": "Vichayal"
    }
  ],
  "2006": [
    {
      "id": "200601",
      "nombre": "Sullana"
    },
    {
      "id": "200602",
      "nombre": "Bellavista"
    },
    {
      "id": "200603",
      "nombre": "Ignacio Escudero"
    },
    {
      "id": "200604",
      "nombre": "Lancones"
    },
    {
      "id": "200605",
      "nombre": "Marcavelica"
    },
    {
      "id": "200606",
      "nombre": "Miguel Checa"
    },
    {
      "id": "200607",
      "nombre": "Querecotillo"
    },
    {
      "id": "200608",
      "nombre": "Salitral"
    }
  ],
  "2007": [
    {
      "id": "200701",
      "nombre": "Pariqas"
    },
    {
      "id": "200702",
      "nombre": "El Alto"
    },
    {
      "id": "200703",
      "nombre": "La Brea"
    },
    {
      "id": "200704",
      "nombre": "Lobitos"
    },
    {
      "id": "200705",
      "nombre": "Los Organos"
    },
    {
      "id": "200706",
      "nombre": "Mancora"
    }
  ],
  "2008": [
    {
      "id": "200801",
      "nombre": "Sechura"
    },
    {
      "id": "200802",
      "nombre": "Bellavista de la Union"
    },
    {
      "id": "200803",
      "nombre": "Bernal"
    },
    {
      "id": "200804",
      "nombre": "Cristo Nos Valga"
    },
    {
      "id": "200805",
      "nombre": "Vice"
    },
    {
      "id": "200806",
      "nombre": "Rinconada Llicuar"
    }
  ],
  "2101": [
    {
      "id": "210101",
      "nombre": "Puno"
    },
    {
      "id": "210102",
      "nombre": "Acora"
    },
    {
      "id": "210103",
      "nombre": "Amantani"
    },
    {
      "id": "210104",
      "nombre": "Atuncolla"
    },
    {
      "id": "210105",
      "nombre": "Capachica"
    },
    {
      "id": "210106",
      "nombre": "Chucuito"
    },
    {
      "id": "210107",
      "nombre": "Coata"
    },
    {
      "id": "210108",
      "nombre": "Huata"
    },
    {
      "id": "210109",
      "nombre": "Maqazo"
    },
    {
      "id": "210110",
      "nombre": "Paucarcolla"
    },
    {
      "id": "210111",
      "nombre": "Pichacani"
    },
    {
      "id": "210112",
      "nombre": "Plateria"
    },
    {
      "id": "210113",
      "nombre": "San Antonio"
    },
    {
      "id": "210114",
      "nombre": "Tiquillaca"
    },
    {
      "id": "210115",
      "nombre": "Vilque"
    }
  ],
  "2102": [
    {
      "id": "210201",
      "nombre": "Azangaro"
    },
    {
      "id": "210202",
      "nombre": "Achaya"
    },
    {
      "id": "210203",
      "nombre": "Arapa"
    },
    {
      "id": "210204",
      "nombre": "Asillo"
    },
    {
      "id": "210205",
      "nombre": "Caminaca"
    },
    {
      "id": "210206",
      "nombre": "Chupa"
    },
    {
      "id": "210207",
      "nombre": "Jose Domingo Choquehuanca"
    },
    {
      "id": "210208",
      "nombre": "Muqani"
    },
    {
      "id": "210209",
      "nombre": "Potoni"
    },
    {
      "id": "210210",
      "nombre": "Saman"
    },
    {
      "id": "210211",
      "nombre": "San Anton"
    },
    {
      "id": "210212",
      "nombre": "San Jose"
    },
    {
      "id": "210213",
      "nombre": "San Juan de Salinas"
    },
    {
      "id": "210214",
      "nombre": "Santiago de Pupuja"
    },
    {
      "id": "210215",
      "nombre": "Tirapata"
    }
  ],
  "2103": [
    {
      "id": "210301",
      "nombre": "Macusani"
    },
    {
      "id": "210302",
      "nombre": "Ajoyani"
    },
    {
      "id": "210303",
      "nombre": "Ayapata"
    },
    {
      "id": "210304",
      "nombre": "Coasa"
    },
    {
      "id": "210305",
      "nombre": "Corani"
    },
    {
      "id": "210306",
      "nombre": "Crucero"
    },
    {
      "id": "210307",
      "nombre": "Ituata"
    },
    {
      "id": "210308",
      "nombre": "Ollachea"
    },
    {
      "id": "210309",
      "nombre": "San Gaban"
    },
    {
      "id": "210310",
      "nombre": "Usicayos"
    }
  ],
  "2104": [
    {
      "id": "210401",
      "nombre": "Juli"
    },
    {
      "id": "210402",
      "nombre": "Desaguadero"
    },
    {
      "id": "210403",
      "nombre": "Huacullani"
    },
    {
      "id": "210404",
      "nombre": "Kelluyo"
    },
    {
      "id": "210405",
      "nombre": "Pisacoma"
    },
    {
      "id": "210406",
      "nombre": "Pomata"
    },
    {
      "id": "210407",
      "nombre": "Zepita"
    }
  ],
  "2105": [
    {
      "id": "210501",
      "nombre": "Ilave"
    },
    {
      "id": "210502",
      "nombre": "Capazo"
    },
    {
      "id": "210503",
      "nombre": "Pilcuyo"
    },
    {
      "id": "210504",
      "nombre": "Santa Rosa"
    },
    {
      "id": "210505",
      "nombre": "Conduriri"
    }
  ],
  "2106": [
    {
      "id": "210601",
      "nombre": "Huancane"
    },
    {
      "id": "210602",
      "nombre": "Cojata"
    },
    {
      "id": "210603",
      "nombre": "Huatasani"
    },
    {
      "id": "210604",
      "nombre": "Inchupalla"
    },
    {
      "id": "210605",
      "nombre": "Pusi"
    },
    {
      "id": "210606",
      "nombre": "Rosaspata"
    },
    {
      "id": "210607",
      "nombre": "Taraco"
    },
    {
      "id": "210608",
      "nombre": "Vilque Chico"
    }
  ],
  "2107": [
    {
      "id": "210701",
      "nombre": "Lampa"
    },
    {
      "id": "210702",
      "nombre": "Cabanilla"
    },
    {
      "id": "210703",
      "nombre": "Calapuja"
    },
    {
      "id": "210704",
      "nombre": "Nicasio"
    },
    {
      "id": "210705",
      "nombre": "Ocuviri"
    },
    {
      "id": "210706",
      "nombre": "Palca"
    },
    {
      "id": "210707",
      "nombre": "Paratia"
    },
    {
      "id": "210708",
      "nombre": "Pucara"
    },
    {
      "id": "210709",
      "nombre": "Santa Lucia"
    },
    {
      "id": "210710",
      "nombre": "Vilavila"
    }
  ],
  "2108": [
    {
      "id": "210801",
      "nombre": "Ayaviri"
    },
    {
      "id": "210802",
      "nombre": "Antauta"
    },
    {
      "id": "210803",
      "nombre": "Cupi"
    },
    {
      "id": "210804",
      "nombre": "Llalli"
    },
    {
      "id": "210805",
      "nombre": "Macari"
    },
    {
      "id": "210806",
      "nombre": "Nuqoa"
    },
    {
      "id": "210807",
      "nombre": "Orurillo"
    },
    {
      "id": "210808",
      "nombre": "Santa Rosa"
    },
    {
      "id": "210809",
      "nombre": "Umachiri"
    }
  ],
  "2109": [
    {
      "id": "210901",
      "nombre": "Moho"
    },
    {
      "id": "210902",
      "nombre": "Conima"
    },
    {
      "id": "210903",
      "nombre": "Huayrapata"
    },
    {
      "id": "210904",
      "nombre": "Tilali"
    }
  ],
  "2110": [
    {
      "id": "211001",
      "nombre": "Putina"
    },
    {
      "id": "211002",
      "nombre": "Ananea"
    },
    {
      "id": "211003",
      "nombre": "Pedro Vilca Apaza"
    },
    {
      "id": "211004",
      "nombre": "Quilcapuncu"
    },
    {
      "id": "211005",
      "nombre": "Sina"
    }
  ],
  "2111": [
    {
      "id": "211101",
      "nombre": "Juliaca"
    },
    {
      "id": "211102",
      "nombre": "Cabana"
    },
    {
      "id": "211103",
      "nombre": "Cabanillas"
    },
    {
      "id": "211104",
      "nombre": "Caracoto"
    }
  ],
  "2112": [
    {
      "id": "211201",
      "nombre": "Sandia"
    },
    {
      "id": "211202",
      "nombre": "Cuyocuyo"
    },
    {
      "id": "211203",
      "nombre": "Limbani"
    },
    {
      "id": "211204",
      "nombre": "Patambuco"
    },
    {
      "id": "211205",
      "nombre": "Phara"
    },
    {
      "id": "211206",
      "nombre": "Quiaca"
    },
    {
      "id": "211207",
      "nombre": "San Juan del Oro"
    },
    {
      "id": "211208",
      "nombre": "Yanahuaya"
    },
    {
      "id": "211209",
      "nombre": "Alto Inambari"
    }
  ],
  "2113": [
    {
      "id": "211301",
      "nombre": "Yunguyo"
    },
    {
      "id": "211302",
      "nombre": "Anapia"
    },
    {
      "id": "211303",
      "nombre": "Copani"
    },
    {
      "id": "211304",
      "nombre": "Cuturapi"
    },
    {
      "id": "211305",
      "nombre": "Ollaraya"
    },
    {
      "id": "211306",
      "nombre": "Tinicachi"
    },
    {
      "id": "211307",
      "nombre": "Unicachi"
    }
  ],
  "2201": [
    {
      "id": "220101",
      "nombre": "Moyobamba"
    },
    {
      "id": "220102",
      "nombre": "Calzada"
    },
    {
      "id": "220103",
      "nombre": "Habana"
    },
    {
      "id": "220104",
      "nombre": "Jepelacio"
    },
    {
      "id": "220105",
      "nombre": "Soritor"
    },
    {
      "id": "220106",
      "nombre": "Yantalo"
    }
  ],
  "2202": [
    {
      "id": "220201",
      "nombre": "Bellavista"
    },
    {
      "id": "220202",
      "nombre": "Alto Biavo"
    },
    {
      "id": "220203",
      "nombre": "Bajo Biavo"
    },
    {
      "id": "220204",
      "nombre": "Huallaga"
    },
    {
      "id": "220205",
      "nombre": "San Pablo"
    },
    {
      "id": "220206",
      "nombre": "San Rafael"
    }
  ],
  "2203": [
    {
      "id": "220301",
      "nombre": "San Jose de Sisa"
    },
    {
      "id": "220302",
      "nombre": "Agua Blanca"
    },
    {
      "id": "220303",
      "nombre": "San Martin"
    },
    {
      "id": "220304",
      "nombre": "Santa Rosa"
    },
    {
      "id": "220305",
      "nombre": "Shatoja"
    }
  ],
  "2204": [
    {
      "id": "220401",
      "nombre": "Saposoa"
    },
    {
      "id": "220402",
      "nombre": "Alto Saposoa"
    },
    {
      "id": "220403",
      "nombre": "El Eslabon"
    },
    {
      "id": "220404",
      "nombre": "Piscoyacu"
    },
    {
      "id": "220405",
      "nombre": "Sacanche"
    },
    {
      "id": "220406",
      "nombre": "Tingo de Saposoa"
    }
  ],
  "2205": [
    {
      "id": "220501",
      "nombre": "Lamas"
    },
    {
      "id": "220502",
      "nombre": "Alonso de Alvarado"
    },
    {
      "id": "220503",
      "nombre": "Barranquita"
    },
    {
      "id": "220504",
      "nombre": "Caynarachi"
    },
    {
      "id": "220505",
      "nombre": "Cuqumbuqui"
    },
    {
      "id": "220506",
      "nombre": "Pinto Recodo"
    },
    {
      "id": "220507",
      "nombre": "Rumisapa"
    },
    {
      "id": "220508",
      "nombre": "San Roque de Cumbaza"
    },
    {
      "id": "220509",
      "nombre": "Shanao"
    },
    {
      "id": "220510",
      "nombre": "Tabalosos"
    },
    {
      "id": "220511",
      "nombre": "Zapatero"
    }
  ],
  "2206": [
    {
      "id": "220601",
      "nombre": "Juanjui"
    },
    {
      "id": "220602",
      "nombre": "Campanilla"
    },
    {
      "id": "220603",
      "nombre": "Huicungo"
    },
    {
      "id": "220604",
      "nombre": "Pachiza"
    },
    {
      "id": "220605",
      "nombre": "Pajarillo"
    }
  ],
  "2207": [
    {
      "id": "220701",
      "nombre": "Picota"
    },
    {
      "id": "220702",
      "nombre": "Buenos Aires"
    },
    {
      "id": "220703",
      "nombre": "Caspisapa"
    },
    {
      "id": "220704",
      "nombre": "Pilluana"
    },
    {
      "id": "220705",
      "nombre": "Pucacaca"
    },
    {
      "id": "220706",
      "nombre": "San Cristobal"
    },
    {
      "id": "220707",
      "nombre": "San Hilarion"
    },
    {
      "id": "220708",
      "nombre": "Shamboyacu"
    },
    {
      "id": "220709",
      "nombre": "Tingo de Ponasa"
    },
    {
      "id": "220710",
      "nombre": "Tres Unidos"
    }
  ],
  "2208": [
    {
      "id": "220801",
      "nombre": "Rioja"
    },
    {
      "id": "220802",
      "nombre": "Awajun"
    },
    {
      "id": "220803",
      "nombre": "Elias Soplin Vargas"
    },
    {
      "id": "220804",
      "nombre": "Nueva Cajamarca"
    },
    {
      "id": "220805",
      "nombre": "Pardo Miguel"
    },
    {
      "id": "220806",
      "nombre": "Posic"
    },
    {
      "id": "220807",
      "nombre": "San Fernando"
    },
    {
      "id": "220808",
      "nombre": "Yorongos"
    },
    {
      "id": "220809",
      "nombre": "Yuracyacu"
    }
  ],
  "2209": [
    {
      "id": "220901",
      "nombre": "Tarapoto"
    },
    {
      "id": "220902",
      "nombre": "Alberto Leveau"
    },
    {
      "id": "220903",
      "nombre": "Cacatachi"
    },
    {
      "id": "220904",
      "nombre": "Chazuta"
    },
    {
      "id": "220905",
      "nombre": "Chipurana"
    },
    {
      "id": "220906",
      "nombre": "El Porvenir"
    },
    {
      "id": "220907",
      "nombre": "Huimbayoc"
    },
    {
      "id": "220908",
      "nombre": "Juan Guerra"
    },
    {
      "id": "220909",
      "nombre": "La Banda de Shilcayo"
    },
    {
      "id": "220910",
      "nombre": "Morales"
    },
    {
      "id": "220911",
      "nombre": "Papaplaya"
    },
    {
      "id": "220912",
      "nombre": "San Antonio"
    },
    {
      "id": "220913",
      "nombre": "Sauce"
    },
    {
      "id": "220914",
      "nombre": "Shapaja"
    }
  ],
  "2210": [
    {
      "id": "221001",
      "nombre": "Tocache"
    },
    {
      "id": "221002",
      "nombre": "Nuevo Progreso"
    },
    {
      "id": "221003",
      "nombre": "Polvora"
    },
    {
      "id": "221004",
      "nombre": "Shunte"
    },
    {
      "id": "221005",
      "nombre": "Uchiza"
    }
  ],
  "2301": [
    {
      "id": "230101",
      "nombre": "Tacna"
    },
    {
      "id": "230102",
      "nombre": "Alto de la Alianza"
    },
    {
      "id": "230103",
      "nombre": "Calana"
    },
    {
      "id": "230104",
      "nombre": "Ciudad Nueva"
    },
    {
      "id": "230105",
      "nombre": "Inclan"
    },
    {
      "id": "230106",
      "nombre": "Pachia"
    },
    {
      "id": "230107",
      "nombre": "Palca"
    },
    {
      "id": "230108",
      "nombre": "Pocollay"
    },
    {
      "id": "230109",
      "nombre": "Sama"
    },
    {
      "id": "230110",
      "nombre": "Cor Gregorio Albarracín"
    }
  ],
  "2302": [
    {
      "id": "230201",
      "nombre": "Candarave"
    },
    {
      "id": "230202",
      "nombre": "Cairani"
    },
    {
      "id": "230203",
      "nombre": "Camilaca"
    },
    {
      "id": "230204",
      "nombre": "Curibaya"
    },
    {
      "id": "230205",
      "nombre": "Huanuara"
    },
    {
      "id": "230206",
      "nombre": "Quilahuani"
    }
  ],
  "2303": [
    {
      "id": "230301",
      "nombre": "Locumba"
    },
    {
      "id": "230302",
      "nombre": "Ilabaya"
    },
    {
      "id": "230303",
      "nombre": "Ite"
    }
  ],
  "2304": [
    {
      "id": "230401",
      "nombre": "Tarata"
    },
    {
      "id": "230402",
      "nombre": "Chucatamani"
    },
    {
      "id": "230403",
      "nombre": "Estique"
    },
    {
      "id": "230404",
      "nombre": "Estique-Pampa"
    },
    {
      "id": "230405",
      "nombre": "Sitajara"
    },
    {
      "id": "230406",
      "nombre": "Susapaya"
    },
    {
      "id": "230407",
      "nombre": "Tarucachi"
    },
    {
      "id": "230408",
      "nombre": "Ticaco"
    }
  ],
  "2401": [
    {
      "id": "240101",
      "nombre": "Tumbes"
    },
    {
      "id": "240102",
      "nombre": "Corrales"
    },
    {
      "id": "240103",
      "nombre": "La Cruz"
    },
    {
      "id": "240104",
      "nombre": "Pampas de Hospital"
    },
    {
      "id": "240105",
      "nombre": "San Jacinto"
    },
    {
      "id": "240106",
      "nombre": "San Juan de la Virgen"
    }
  ],
  "2402": [
    {
      "id": "240201",
      "nombre": "Zorritos"
    },
    {
      "id": "240202",
      "nombre": "Casitas"
    }
  ],
  "2403": [
    {
      "id": "240301",
      "nombre": "Zarumilla"
    },
    {
      "id": "240302",
      "nombre": "Aguas Verdes"
    },
    {
      "id": "240303",
      "nombre": "Matapalo"
    },
    {
      "id": "240304",
      "nombre": "Papayal"
    }
  ],
  "2501": [
    {
      "id": "250101",
      "nombre": "Calleria"
    },
    {
      "id": "250102",
      "nombre": "Campoverde"
    },
    {
      "id": "250103",
      "nombre": "Iparia"
    },
    {
      "id": "250104",
      "nombre": "Masisea"
    },
    {
      "id": "250105",
      "nombre": "Yarinacocha"
    },
    {
      "id": "250106",
      "nombre": "Nueva Requena"
    }
  ],
  "2502": [
    {
      "id": "250201",
      "nombre": "Raymondi"
    },
    {
      "id": "250202",
      "nombre": "Sepahua"
    },
    {
      "id": "250203",
      "nombre": "Tahuania"
    },
    {
      "id": "250204",
      "nombre": "Yurua"
    }
  ],
  "2503": [
    {
      "id": "250301",
      "nombre": "Padre Abad"
    },
    {
      "id": "250302",
      "nombre": "Irazola"
    },
    {
      "id": "250303",
      "nombre": "Curimana"
    }
  ],
  "2504": [
    {
      "id": "250401",
      "nombre": "Purus"
    }
  ],
  "0101": [
    {
      "id": "010101",
      "nombre": "Chachapoyas"
    },
    {
      "id": "010102",
      "nombre": "Asuncion"
    },
    {
      "id": "010103",
      "nombre": "Balsas"
    },
    {
      "id": "010104",
      "nombre": "Cheto"
    },
    {
      "id": "010105",
      "nombre": "Chiliquin"
    },
    {
      "id": "010106",
      "nombre": "Chuquibamba"
    },
    {
      "id": "010107",
      "nombre": "Granada"
    },
    {
      "id": "010108",
      "nombre": "Huancas"
    },
    {
      "id": "010109",
      "nombre": "La Jalca"
    },
    {
      "id": "010110",
      "nombre": "Leimebamba"
    },
    {
      "id": "010111",
      "nombre": "Levanto"
    },
    {
      "id": "010112",
      "nombre": "Magdalena"
    },
    {
      "id": "010113",
      "nombre": "Mariscal Castilla"
    },
    {
      "id": "010114",
      "nombre": "Molinopampa"
    },
    {
      "id": "010115",
      "nombre": "Montevideo"
    },
    {
      "id": "010116",
      "nombre": "Olleros"
    },
    {
      "id": "010117",
      "nombre": "Quinjalca"
    },
    {
      "id": "010118",
      "nombre": "San Francisco de Daguas"
    },
    {
      "id": "010119",
      "nombre": "San Isidro de Maino"
    },
    {
      "id": "010120",
      "nombre": "Soloco"
    },
    {
      "id": "010121",
      "nombre": "Sonche"
    }
  ],
  "0102": [
    {
      "id": "010201",
      "nombre": "La Peca"
    },
    {
      "id": "010202",
      "nombre": "Aramango"
    },
    {
      "id": "010203",
      "nombre": "Copallin"
    },
    {
      "id": "010204",
      "nombre": "El Parco"
    },
    {
      "id": "010205",
      "nombre": "Imaza"
    }
  ],
  "0103": [
    {
      "id": "010301",
      "nombre": "Jumbilla"
    },
    {
      "id": "010302",
      "nombre": "Corosha"
    },
    {
      "id": "010303",
      "nombre": "Cuispes"
    },
    {
      "id": "010304",
      "nombre": "Chisquilla"
    },
    {
      "id": "010305",
      "nombre": "Churuja"
    },
    {
      "id": "010306",
      "nombre": "Florida"
    },
    {
      "id": "010307",
      "nombre": "Recta"
    },
    {
      "id": "010308",
      "nombre": "San Carlos"
    },
    {
      "id": "010309",
      "nombre": "Shipasbamba"
    },
    {
      "id": "010310",
      "nombre": "Valera"
    },
    {
      "id": "010311",
      "nombre": "Yambrasbamba"
    },
    {
      "id": "010312",
      "nombre": "Jazan"
    }
  ],
  "0104": [
    {
      "id": "010401",
      "nombre": "Nieva"
    },
    {
      "id": "010402",
      "nombre": "El Cenepa"
    },
    {
      "id": "010403",
      "nombre": "Rio Santiago"
    }
  ],
  "0105": [
    {
      "id": "010501",
      "nombre": "Lamud"
    },
    {
      "id": "010502",
      "nombre": "Camporredondo"
    },
    {
      "id": "010503",
      "nombre": "Cocabamba"
    },
    {
      "id": "010504",
      "nombre": "Colcamar"
    },
    {
      "id": "010505",
      "nombre": "Conila"
    },
    {
      "id": "010506",
      "nombre": "Inguilpata"
    },
    {
      "id": "010507",
      "nombre": "Longuita"
    },
    {
      "id": "010508",
      "nombre": "Lonya Chico"
    },
    {
      "id": "010509",
      "nombre": "Luya"
    },
    {
      "id": "010510",
      "nombre": "Luya Viejo"
    },
    {
      "id": "010511",
      "nombre": "Maria"
    },
    {
      "id": "010512",
      "nombre": "Ocalli"
    },
    {
      "id": "010513",
      "nombre": "Ocumal"
    },
    {
      "id": "010514",
      "nombre": "Pisuquia"
    },
    {
      "id": "010515",
      "nombre": "Providencia"
    },
    {
      "id": "010516",
      "nombre": "San Cristobal"
    },
    {
      "id": "010517",
      "nombre": "San Francisco del Yeso"
    },
    {
      "id": "010518",
      "nombre": "San Jeronimo"
    },
    {
      "id": "010519",
      "nombre": "San Juan de Lopecancha"
    },
    {
      "id": "010520",
      "nombre": "Santa Catalina"
    },
    {
      "id": "010521",
      "nombre": "Santo Tomas"
    },
    {
      "id": "010522",
      "nombre": "Tingo"
    },
    {
      "id": "010523",
      "nombre": "Trita"
    }
  ],
  "0106": [
    {
      "id": "010601",
      "nombre": "San Nicolas"
    },
    {
      "id": "010602",
      "nombre": "Chirimoto"
    },
    {
      "id": "010603",
      "nombre": "Cochamal"
    },
    {
      "id": "010604",
      "nombre": "Huambo"
    },
    {
      "id": "010605",
      "nombre": "Limabamba"
    },
    {
      "id": "010606",
      "nombre": "Longar"
    },
    {
      "id": "010607",
      "nombre": "Mariscal Benavides"
    },
    {
      "id": "010608",
      "nombre": "Milpuc"
    },
    {
      "id": "010609",
      "nombre": "Omia"
    },
    {
      "id": "010610",
      "nombre": "Santa Rosa"
    },
    {
      "id": "010611",
      "nombre": "Totora"
    },
    {
      "id": "010612",
      "nombre": "Vista Alegre"
    }
  ],
  "0107": [
    {
      "id": "010701",
      "nombre": "Bagua Grande"
    },
    {
      "id": "010702",
      "nombre": "Cajaruro"
    },
    {
      "id": "010703",
      "nombre": "Cumba"
    },
    {
      "id": "010704",
      "nombre": "El Milagro"
    },
    {
      "id": "010705",
      "nombre": "Jamalca"
    },
    {
      "id": "010706",
      "nombre": "Lonya Grande"
    },
    {
      "id": "010707",
      "nombre": "Yamon"
    }
  ],
  "0201": [
    {
      "id": "020101",
      "nombre": "Huaraz"
    },
    {
      "id": "020102",
      "nombre": "Cochabamba"
    },
    {
      "id": "020103",
      "nombre": "Colcabamba"
    },
    {
      "id": "020104",
      "nombre": "Huanchay"
    },
    {
      "id": "020105",
      "nombre": "Independencia"
    },
    {
      "id": "020106",
      "nombre": "Jangas"
    },
    {
      "id": "020107",
      "nombre": "La Libertad"
    },
    {
      "id": "020108",
      "nombre": "Olleros"
    },
    {
      "id": "020109",
      "nombre": "Pampas"
    },
    {
      "id": "020110",
      "nombre": "Pariacoto"
    },
    {
      "id": "020111",
      "nombre": "Pira"
    },
    {
      "id": "020112",
      "nombre": "Tarica"
    }
  ],
  "0202": [
    {
      "id": "020201",
      "nombre": "Aija"
    },
    {
      "id": "020202",
      "nombre": "Coris"
    },
    {
      "id": "020203",
      "nombre": "Huacllan"
    },
    {
      "id": "020204",
      "nombre": "La Merced"
    },
    {
      "id": "020205",
      "nombre": "Succha"
    }
  ],
  "0203": [
    {
      "id": "020301",
      "nombre": "Llamellin"
    },
    {
      "id": "020302",
      "nombre": "Aczo"
    },
    {
      "id": "020303",
      "nombre": "Chaccho"
    },
    {
      "id": "020304",
      "nombre": "Chingas"
    },
    {
      "id": "020305",
      "nombre": "Mirgas"
    },
    {
      "id": "020306",
      "nombre": "San Juan de Rontoy"
    }
  ],
  "0204": [
    {
      "id": "020401",
      "nombre": "Chacas"
    },
    {
      "id": "020402",
      "nombre": "Acochaca"
    }
  ],
  "0205": [
    {
      "id": "020501",
      "nombre": "Chiquian"
    },
    {
      "id": "020502",
      "nombre": "Abelardo Pardo Lezameta"
    },
    {
      "id": "020503",
      "nombre": "Antonio Raymondi"
    },
    {
      "id": "020504",
      "nombre": "Aquia"
    },
    {
      "id": "020505",
      "nombre": "Cajacay"
    },
    {
      "id": "020506",
      "nombre": "Canis"
    },
    {
      "id": "020507",
      "nombre": "Colquioc"
    },
    {
      "id": "020508",
      "nombre": "Huallanca"
    },
    {
      "id": "020509",
      "nombre": "Huasta"
    },
    {
      "id": "020510",
      "nombre": "Huayllacayan"
    },
    {
      "id": "020511",
      "nombre": "La Primavera"
    },
    {
      "id": "020512",
      "nombre": "Mangas"
    },
    {
      "id": "020513",
      "nombre": "Pacllon"
    },
    {
      "id": "020514",
      "nombre": "San Miguel de Corpanqui"
    },
    {
      "id": "020515",
      "nombre": "Ticllos"
    }
  ],
  "0206": [
    {
      "id": "020601",
      "nombre": "Carhuaz"
    },
    {
      "id": "020602",
      "nombre": "Acopampa"
    },
    {
      "id": "020603",
      "nombre": "Amashca"
    },
    {
      "id": "020604",
      "nombre": "Anta"
    },
    {
      "id": "020605",
      "nombre": "Ataquero"
    },
    {
      "id": "020606",
      "nombre": "Marcara"
    },
    {
      "id": "020607",
      "nombre": "Pariahuanca"
    },
    {
      "id": "020608",
      "nombre": "San Miguel de Aco"
    },
    {
      "id": "020609",
      "nombre": "Shilla"
    },
    {
      "id": "020610",
      "nombre": "Tinco"
    },
    {
      "id": "020611",
      "nombre": "Yungar"
    }
  ],
  "0207": [
    {
      "id": "020701",
      "nombre": "San Luis"
    },
    {
      "id": "020702",
      "nombre": "San Nicolas"
    },
    {
      "id": "020703",
      "nombre": "Yauya"
    }
  ],
  "0208": [
    {
      "id": "020801",
      "nombre": "Casma"
    },
    {
      "id": "020802",
      "nombre": "Buena Vista Alta"
    },
    {
      "id": "020803",
      "nombre": "Comandante Noel"
    },
    {
      "id": "020804",
      "nombre": "Yautan"
    }
  ],
  "0209": [
    {
      "id": "020901",
      "nombre": "Corongo"
    },
    {
      "id": "020902",
      "nombre": "Aco"
    },
    {
      "id": "020903",
      "nombre": "Bambas"
    },
    {
      "id": "020904",
      "nombre": "Cusca"
    },
    {
      "id": "020905",
      "nombre": "La Pampa"
    },
    {
      "id": "020906",
      "nombre": "Yanac"
    },
    {
      "id": "020907",
      "nombre": "Yupan"
    }
  ],
  "0210": [
    {
      "id": "021001",
      "nombre": "Huari"
    },
    {
      "id": "021002",
      "nombre": "Anra"
    },
    {
      "id": "021003",
      "nombre": "Cajay"
    },
    {
      "id": "021004",
      "nombre": "Chavin de Huantar"
    },
    {
      "id": "021005",
      "nombre": "Huacachi"
    },
    {
      "id": "021006",
      "nombre": "Huacchis"
    },
    {
      "id": "021007",
      "nombre": "Huachis"
    },
    {
      "id": "021008",
      "nombre": "Huantar"
    },
    {
      "id": "021009",
      "nombre": "Masin"
    },
    {
      "id": "021010",
      "nombre": "Paucas"
    },
    {
      "id": "021011",
      "nombre": "Ponto"
    },
    {
      "id": "021012",
      "nombre": "Rahuapampa"
    },
    {
      "id": "021013",
      "nombre": "Rapayan"
    },
    {
      "id": "021014",
      "nombre": "San Marcos"
    },
    {
      "id": "021015",
      "nombre": "San Pedro de Chana"
    },
    {
      "id": "021016",
      "nombre": "Uco"
    }
  ],
  "0211": [
    {
      "id": "021101",
      "nombre": "Huarmey"
    },
    {
      "id": "021102",
      "nombre": "Cochapeti"
    },
    {
      "id": "021103",
      "nombre": "Culebras"
    },
    {
      "id": "021104",
      "nombre": "Huayan"
    },
    {
      "id": "021105",
      "nombre": "Malvas"
    }
  ],
  "0212": [
    {
      "id": "021201",
      "nombre": "Caraz"
    },
    {
      "id": "021202",
      "nombre": "Huallanca"
    },
    {
      "id": "021203",
      "nombre": "Huata"
    },
    {
      "id": "021204",
      "nombre": "Huaylas"
    },
    {
      "id": "021205",
      "nombre": "Mato"
    },
    {
      "id": "021206",
      "nombre": "Pamparomas"
    },
    {
      "id": "021207",
      "nombre": "Pueblo Libre"
    },
    {
      "id": "021208",
      "nombre": "Santa Cruz"
    },
    {
      "id": "021209",
      "nombre": "Santo Toribio"
    },
    {
      "id": "021210",
      "nombre": "Yuracmarca"
    }
  ],
  "0213": [
    {
      "id": "021301",
      "nombre": "Piscobamba"
    },
    {
      "id": "021302",
      "nombre": "Casca"
    },
    {
      "id": "021303",
      "nombre": "Eleazar Guzman Barron"
    },
    {
      "id": "021304",
      "nombre": "Fidel Olivas Escudero"
    },
    {
      "id": "021305",
      "nombre": "Llama"
    },
    {
      "id": "021306",
      "nombre": "Llumpa"
    },
    {
      "id": "021307",
      "nombre": "Lucma"
    },
    {
      "id": "021308",
      "nombre": "Musga"
    }
  ],
  "0214": [
    {
      "id": "021401",
      "nombre": "Ocros"
    },
    {
      "id": "021402",
      "nombre": "Acas"
    },
    {
      "id": "021403",
      "nombre": "Cajamarquilla"
    },
    {
      "id": "021404",
      "nombre": "Carhuapampa"
    },
    {
      "id": "021405",
      "nombre": "Cochas"
    },
    {
      "id": "021406",
      "nombre": "Congas"
    },
    {
      "id": "021407",
      "nombre": "Llipa"
    },
    {
      "id": "021408",
      "nombre": "San Cristobal de Rajan"
    },
    {
      "id": "021409",
      "nombre": "San Pedro"
    },
    {
      "id": "021410",
      "nombre": "Santiago de Chilcas"
    }
  ],
  "0215": [
    {
      "id": "021501",
      "nombre": "Cabana"
    },
    {
      "id": "021502",
      "nombre": "Bolognesi"
    },
    {
      "id": "021503",
      "nombre": "Conchucos"
    },
    {
      "id": "021504",
      "nombre": "Huacaschuque"
    },
    {
      "id": "021505",
      "nombre": "Huandoval"
    },
    {
      "id": "021506",
      "nombre": "Lacabamba"
    },
    {
      "id": "021507",
      "nombre": "Llapo"
    },
    {
      "id": "021508",
      "nombre": "Pallasca"
    },
    {
      "id": "021509",
      "nombre": "Pampas"
    },
    {
      "id": "021510",
      "nombre": "Santa Rosa"
    },
    {
      "id": "021511",
      "nombre": "Tauca"
    }
  ],
  "0216": [
    {
      "id": "021601",
      "nombre": "Pomabamba"
    },
    {
      "id": "021602",
      "nombre": "Huayllan"
    },
    {
      "id": "021603",
      "nombre": "Parobamba"
    },
    {
      "id": "021604",
      "nombre": "Quinuabamba"
    }
  ],
  "0217": [
    {
      "id": "021701",
      "nombre": "Recuay"
    },
    {
      "id": "021702",
      "nombre": "Catac"
    },
    {
      "id": "021703",
      "nombre": "Cotaparaco"
    },
    {
      "id": "021704",
      "nombre": "Huayllapampa"
    },
    {
      "id": "021705",
      "nombre": "Llacllin"
    },
    {
      "id": "021706",
      "nombre": "Marca"
    },
    {
      "id": "021707",
      "nombre": "Pampas Chico"
    },
    {
      "id": "021708",
      "nombre": "Pararin"
    },
    {
      "id": "021709",
      "nombre": "Tapacocha"
    },
    {
      "id": "021710",
      "nombre": "Ticapampa"
    }
  ],
  "0218": [
    {
      "id": "021801",
      "nombre": "Chimbote"
    },
    {
      "id": "021802",
      "nombre": "Caceres del Peru"
    },
    {
      "id": "021803",
      "nombre": "Coishco"
    },
    {
      "id": "021804",
      "nombre": "Macate"
    },
    {
      "id": "021805",
      "nombre": "Moro"
    },
    {
      "id": "021806",
      "nombre": "Nepeqa"
    },
    {
      "id": "021807",
      "nombre": "Samanco"
    },
    {
      "id": "021808",
      "nombre": "Santa"
    },
    {
      "id": "021809",
      "nombre": "Nuevo Chimbote"
    }
  ],
  "0219": [
    {
      "id": "021901",
      "nombre": "Sihuas"
    },
    {
      "id": "021902",
      "nombre": "Acobamba"
    },
    {
      "id": "021903",
      "nombre": "Alfonso Ugarte"
    },
    {
      "id": "021904",
      "nombre": "Cashapampa"
    },
    {
      "id": "021905",
      "nombre": "Chingalpo"
    },
    {
      "id": "021906",
      "nombre": "Huayllabamba"
    },
    {
      "id": "021907",
      "nombre": "Quiches"
    },
    {
      "id": "021908",
      "nombre": "Ragash"
    },
    {
      "id": "021909",
      "nombre": "San Juan"
    },
    {
      "id": "021910",
      "nombre": "Sicsibamba"
    }
  ],
  "0220": [
    {
      "id": "022001",
      "nombre": "Yungay"
    },
    {
      "id": "022002",
      "nombre": "Cascapara"
    },
    {
      "id": "022003",
      "nombre": "Mancos"
    },
    {
      "id": "022004",
      "nombre": "Matacoto"
    },
    {
      "id": "022005",
      "nombre": "Quillo"
    },
    {
      "id": "022006",
      "nombre": "Ranrahirca"
    },
    {
      "id": "022007",
      "nombre": "Shupluy"
    },
    {
      "id": "022008",
      "nombre": "Yanama"
    }
  ],
  "0301": [
    {
      "id": "030101",
      "nombre": "Abancay"
    },
    {
      "id": "030102",
      "nombre": "Chacoche"
    },
    {
      "id": "030103",
      "nombre": "Circa"
    },
    {
      "id": "030104",
      "nombre": "Curahuasi"
    },
    {
      "id": "030105",
      "nombre": "Huanipaca"
    },
    {
      "id": "030106",
      "nombre": "Lambrama"
    },
    {
      "id": "030107",
      "nombre": "Pichirhua"
    },
    {
      "id": "030108",
      "nombre": "San Pedro de Cachora"
    },
    {
      "id": "030109",
      "nombre": "Tamburco"
    }
  ],
  "0302": [
    {
      "id": "030201",
      "nombre": "Andahuaylas"
    },
    {
      "id": "030202",
      "nombre": "Andarapa"
    },
    {
      "id": "030203",
      "nombre": "Chiara"
    },
    {
      "id": "030204",
      "nombre": "Huancarama"
    },
    {
      "id": "030205",
      "nombre": "Huancaray"
    },
    {
      "id": "030206",
      "nombre": "Huayana"
    },
    {
      "id": "030207",
      "nombre": "Kishuara"
    },
    {
      "id": "030208",
      "nombre": "Pacobamba"
    },
    {
      "id": "030209",
      "nombre": "Pacucha"
    },
    {
      "id": "030210",
      "nombre": "Pampachiri"
    },
    {
      "id": "030211",
      "nombre": "Pomacocha"
    },
    {
      "id": "030212",
      "nombre": "San Antonio de Cachi"
    },
    {
      "id": "030213",
      "nombre": "San Jeronimo"
    },
    {
      "id": "030214",
      "nombre": "San Miguel de Chaccrampa"
    },
    {
      "id": "030215",
      "nombre": "Santa Maria de Chicmo"
    },
    {
      "id": "030216",
      "nombre": "Talavera"
    },
    {
      "id": "030217",
      "nombre": "Tumay Huaraca"
    },
    {
      "id": "030218",
      "nombre": "Turpo"
    },
    {
      "id": "030219",
      "nombre": "Kaquiabamba"
    }
  ],
  "0303": [
    {
      "id": "030301",
      "nombre": "Antabamba"
    },
    {
      "id": "030302",
      "nombre": "El Oro"
    },
    {
      "id": "030303",
      "nombre": "Huaquirca"
    },
    {
      "id": "030304",
      "nombre": "Juan Espinoza Medrano"
    },
    {
      "id": "030305",
      "nombre": "Oropesa"
    },
    {
      "id": "030306",
      "nombre": "Pachaconas"
    },
    {
      "id": "030307",
      "nombre": "Sabaino"
    }
  ],
  "0304": [
    {
      "id": "030401",
      "nombre": "Chalhuanca"
    },
    {
      "id": "030402",
      "nombre": "Capaya"
    },
    {
      "id": "030403",
      "nombre": "Caraybamba"
    },
    {
      "id": "030404",
      "nombre": "Chapimarca"
    },
    {
      "id": "030405",
      "nombre": "Colcabamba"
    },
    {
      "id": "030406",
      "nombre": "Cotaruse"
    },
    {
      "id": "030407",
      "nombre": "Huayllo"
    },
    {
      "id": "030408",
      "nombre": "Justo Apu Sahuaraura"
    },
    {
      "id": "030409",
      "nombre": "Lucre"
    },
    {
      "id": "030410",
      "nombre": "Pocohuanca"
    },
    {
      "id": "030411",
      "nombre": "San Juan de Chacqa"
    },
    {
      "id": "030412",
      "nombre": "Saqayca"
    },
    {
      "id": "030413",
      "nombre": "Soraya"
    },
    {
      "id": "030414",
      "nombre": "Tapairihua"
    },
    {
      "id": "030415",
      "nombre": "Tintay"
    },
    {
      "id": "030416",
      "nombre": "Toraya"
    },
    {
      "id": "030417",
      "nombre": "Yanaca"
    }
  ],
  "0305": [
    {
      "id": "030501",
      "nombre": "Tambobamba"
    },
    {
      "id": "030502",
      "nombre": "Cotabambas"
    },
    {
      "id": "030503",
      "nombre": "Coyllurqui"
    },
    {
      "id": "030504",
      "nombre": "Haquira"
    },
    {
      "id": "030505",
      "nombre": "Mara"
    },
    {
      "id": "030506",
      "nombre": "Challhuahuacho"
    }
  ],
  "0306": [
    {
      "id": "030601",
      "nombre": "Chincheros"
    },
    {
      "id": "030602",
      "nombre": "Anco-Huallo"
    },
    {
      "id": "030603",
      "nombre": "Cocharcas"
    },
    {
      "id": "030604",
      "nombre": "Huaccana"
    },
    {
      "id": "030605",
      "nombre": "Ocobamba"
    },
    {
      "id": "030606",
      "nombre": "Ongoy"
    },
    {
      "id": "030607",
      "nombre": "Uranmarca"
    },
    {
      "id": "030608",
      "nombre": "Ranracancha"
    }
  ],
  "0307": [
    {
      "id": "030701",
      "nombre": "Chuquibambilla"
    },
    {
      "id": "030702",
      "nombre": "Curpahuasi"
    },
    {
      "id": "030703",
      "nombre": "Gamarra"
    },
    {
      "id": "030704",
      "nombre": "Huayllati"
    },
    {
      "id": "030705",
      "nombre": "Mamara"
    },
    {
      "id": "030706",
      "nombre": "Micaela Bastidas"
    },
    {
      "id": "030707",
      "nombre": "Pataypampa"
    },
    {
      "id": "030708",
      "nombre": "Progreso"
    },
    {
      "id": "030709",
      "nombre": "San Antonio"
    },
    {
      "id": "030710",
      "nombre": "Santa Rosa"
    },
    {
      "id": "030711",
      "nombre": "Turpay"
    },
    {
      "id": "030712",
      "nombre": "Vilcabamba"
    },
    {
      "id": "030713",
      "nombre": "Virundo"
    },
    {
      "id": "030714",
      "nombre": "Curasco"
    }
  ],
  "0401": [
    {
      "id": "040101",
      "nombre": "Arequipa"
    },
    {
      "id": "040102",
      "nombre": "Alto Selva Alegre"
    },
    {
      "id": "040103",
      "nombre": "Cayma"
    },
    {
      "id": "040104",
      "nombre": "Cerro Colorado"
    },
    {
      "id": "040105",
      "nombre": "Characato"
    },
    {
      "id": "040106",
      "nombre": "Chiguata"
    },
    {
      "id": "040107",
      "nombre": "Jacobo Hunter"
    },
    {
      "id": "040108",
      "nombre": "La Joya"
    },
    {
      "id": "040109",
      "nombre": "Mariano Melgar"
    },
    {
      "id": "040110",
      "nombre": "Miraflores"
    },
    {
      "id": "040111",
      "nombre": "Mollebaya"
    },
    {
      "id": "040112",
      "nombre": "Paucarpata"
    },
    {
      "id": "040113",
      "nombre": "Pocsi"
    },
    {
      "id": "040114",
      "nombre": "Polobaya"
    },
    {
      "id": "040115",
      "nombre": "Quequeqa"
    },
    {
      "id": "040116",
      "nombre": "Sabandia"
    },
    {
      "id": "040117",
      "nombre": "Sachaca"
    },
    {
      "id": "040118",
      "nombre": "San Juan de Siguas"
    },
    {
      "id": "040119",
      "nombre": "San Juan de Tarucani"
    },
    {
      "id": "040120",
      "nombre": "Santa Isabel de Siguas"
    },
    {
      "id": "040121",
      "nombre": "Santa Rita de Siguas"
    },
    {
      "id": "040122",
      "nombre": "Socabaya"
    },
    {
      "id": "040123",
      "nombre": "Tiabaya"
    },
    {
      "id": "040124",
      "nombre": "Uchumayo"
    },
    {
      "id": "040125",
      "nombre": "Vitor"
    },
    {
      "id": "040126",
      "nombre": "Yanahuara"
    },
    {
      "id": "040127",
      "nombre": "Yarabamba"
    },
    {
      "id": "040128",
      "nombre": "Yura"
    },
    {
      "id": "040129",
      "nombre": "Jose Luis Bustamante y Rivero"
    }
  ],
  "0402": [
    {
      "id": "040201",
      "nombre": "Camana"
    },
    {
      "id": "040202",
      "nombre": "Jose Maria Quimper"
    },
    {
      "id": "040203",
      "nombre": "Mariano Nicolas Valcarcel"
    },
    {
      "id": "040204",
      "nombre": "Mariscal Caceres"
    },
    {
      "id": "040205",
      "nombre": "Nicolas de Pierola"
    },
    {
      "id": "040206",
      "nombre": "Ocoqa"
    },
    {
      "id": "040207",
      "nombre": "Quilca"
    },
    {
      "id": "040208",
      "nombre": "Samuel Pastor"
    }
  ],
  "0403": [
    {
      "id": "040301",
      "nombre": "Caraveli"
    },
    {
      "id": "040302",
      "nombre": "Acari"
    },
    {
      "id": "040303",
      "nombre": "Atico"
    },
    {
      "id": "040304",
      "nombre": "Atiquipa"
    },
    {
      "id": "040305",
      "nombre": "Bella Union"
    },
    {
      "id": "040306",
      "nombre": "Cahuacho"
    },
    {
      "id": "040307",
      "nombre": "Chala"
    },
    {
      "id": "040308",
      "nombre": "Chaparra"
    },
    {
      "id": "040309",
      "nombre": "Huanuhuanu"
    },
    {
      "id": "040310",
      "nombre": "Jaqui"
    },
    {
      "id": "040311",
      "nombre": "Lomas"
    },
    {
      "id": "040312",
      "nombre": "Quicacha"
    },
    {
      "id": "040313",
      "nombre": "Yauca"
    }
  ],
  "0404": [
    {
      "id": "040401",
      "nombre": "Aplao"
    },
    {
      "id": "040402",
      "nombre": "Andagua"
    },
    {
      "id": "040403",
      "nombre": "Ayo"
    },
    {
      "id": "040404",
      "nombre": "Chachas"
    },
    {
      "id": "040405",
      "nombre": "Chilcaymarca"
    },
    {
      "id": "040406",
      "nombre": "Choco"
    },
    {
      "id": "040407",
      "nombre": "Huancarqui"
    },
    {
      "id": "040408",
      "nombre": "Machaguay"
    },
    {
      "id": "040409",
      "nombre": "Orcopampa"
    },
    {
      "id": "040410",
      "nombre": "Pampacolca"
    },
    {
      "id": "040411",
      "nombre": "Tipan"
    },
    {
      "id": "040412",
      "nombre": "Uqon"
    },
    {
      "id": "040413",
      "nombre": "Uraca"
    },
    {
      "id": "040414",
      "nombre": "Viraco"
    },
    {
      "id": "040419",
      "nombre": "Yanque"
    },
    {
      "id": "040420",
      "nombre": "Majes"
    }
  ],
  "0405": [
    {
      "id": "040501",
      "nombre": "Chivay"
    },
    {
      "id": "040502",
      "nombre": "Achoma"
    },
    {
      "id": "040503",
      "nombre": "Cabanaconde"
    },
    {
      "id": "040504",
      "nombre": "Callalli"
    },
    {
      "id": "040505",
      "nombre": "Caylloma"
    },
    {
      "id": "040506",
      "nombre": "Coporaque"
    },
    {
      "id": "040507",
      "nombre": "Huambo"
    },
    {
      "id": "040508",
      "nombre": "Huanca"
    },
    {
      "id": "040509",
      "nombre": "Ichupampa"
    },
    {
      "id": "040510",
      "nombre": "Lari"
    },
    {
      "id": "040511",
      "nombre": "Lluta"
    },
    {
      "id": "040512",
      "nombre": "Maca"
    },
    {
      "id": "040513",
      "nombre": "Madrigal"
    },
    {
      "id": "040514",
      "nombre": "San Antonio de Chuca"
    },
    {
      "id": "040515",
      "nombre": "Sibayo"
    },
    {
      "id": "040516",
      "nombre": "Tapay"
    },
    {
      "id": "040517",
      "nombre": "Tisco"
    },
    {
      "id": "040518",
      "nombre": "Tuti"
    },
    {
      "id": "040519",
      "nombre": "Yanque"
    },
    {
      "id": "040520",
      "nombre": "Majes"
    }
  ],
  "0406": [
    {
      "id": "040601",
      "nombre": "Chuquibamba"
    },
    {
      "id": "040602",
      "nombre": "Andaray"
    },
    {
      "id": "040603",
      "nombre": "Cayarani"
    },
    {
      "id": "040604",
      "nombre": "Chichas"
    },
    {
      "id": "040605",
      "nombre": "Iray"
    },
    {
      "id": "040606",
      "nombre": "Rio Grande"
    },
    {
      "id": "040607",
      "nombre": "Salamanca"
    },
    {
      "id": "040608",
      "nombre": "Yanaquihua"
    }
  ],
  "0407": [
    {
      "id": "040701",
      "nombre": "Mollendo"
    },
    {
      "id": "040702",
      "nombre": "Cocachacra"
    },
    {
      "id": "040703",
      "nombre": "Dean Valdivia"
    },
    {
      "id": "040704",
      "nombre": "Islay"
    },
    {
      "id": "040705",
      "nombre": "Mejia"
    },
    {
      "id": "040706",
      "nombre": "Punta de Bombon"
    }
  ],
  "0408": [
    {
      "id": "040801",
      "nombre": "Cotahuasi"
    },
    {
      "id": "040802",
      "nombre": "Alca"
    },
    {
      "id": "040803",
      "nombre": "Charcana"
    },
    {
      "id": "040804",
      "nombre": "Huaynacotas"
    },
    {
      "id": "040805",
      "nombre": "Pampamarca"
    },
    {
      "id": "040806",
      "nombre": "Puyca"
    },
    {
      "id": "040807",
      "nombre": "Quechualla"
    },
    {
      "id": "040808",
      "nombre": "Sayla"
    },
    {
      "id": "040809",
      "nombre": "Tauria"
    },
    {
      "id": "040810",
      "nombre": "Tomepampa"
    },
    {
      "id": "040811",
      "nombre": "Toro"
    }
  ],
  "0501": [
    {
      "id": "050101",
      "nombre": "Ayacucho"
    },
    {
      "id": "050102",
      "nombre": "Acocro"
    },
    {
      "id": "050103",
      "nombre": "Acos Vinchos"
    },
    {
      "id": "050104",
      "nombre": "Carmen Alto"
    },
    {
      "id": "050105",
      "nombre": "Chiara"
    },
    {
      "id": "050106",
      "nombre": "Ocros"
    },
    {
      "id": "050107",
      "nombre": "Pacaycasa"
    },
    {
      "id": "050108",
      "nombre": "Quinua"
    },
    {
      "id": "050109",
      "nombre": "San Jose de Ticllas"
    },
    {
      "id": "050110",
      "nombre": "San Juan Bautista"
    },
    {
      "id": "050111",
      "nombre": "Santiago de Pischa"
    },
    {
      "id": "050112",
      "nombre": "Socos"
    },
    {
      "id": "050113",
      "nombre": "Tambillo"
    },
    {
      "id": "050114",
      "nombre": "Vinchos"
    },
    {
      "id": "050115",
      "nombre": "Jesús Nazareno"
    }
  ],
  "0502": [
    {
      "id": "050201",
      "nombre": "Cangallo"
    },
    {
      "id": "050202",
      "nombre": "Chuschi"
    },
    {
      "id": "050203",
      "nombre": "Los Morochucos"
    },
    {
      "id": "050204",
      "nombre": "Maria Parado de Bellido"
    },
    {
      "id": "050205",
      "nombre": "Paras"
    },
    {
      "id": "050206",
      "nombre": "Totos"
    }
  ],
  "0503": [
    {
      "id": "050301",
      "nombre": "Sancos"
    },
    {
      "id": "050302",
      "nombre": "Carapo"
    },
    {
      "id": "050303",
      "nombre": "Sacsamarca"
    },
    {
      "id": "050304",
      "nombre": "Santiago de Lucanamarca"
    }
  ],
  "0504": [
    {
      "id": "050401",
      "nombre": "Huanta"
    },
    {
      "id": "050402",
      "nombre": "Ayahuanco"
    },
    {
      "id": "050403",
      "nombre": "Huamanguilla"
    },
    {
      "id": "050404",
      "nombre": "Iguain"
    },
    {
      "id": "050405",
      "nombre": "Luricocha"
    },
    {
      "id": "050406",
      "nombre": "Santillana"
    },
    {
      "id": "050407",
      "nombre": "Sivia"
    },
    {
      "id": "050408",
      "nombre": "Llochegua"
    }
  ],
  "0505": [
    {
      "id": "050501",
      "nombre": "San Miguel"
    },
    {
      "id": "050502",
      "nombre": "Anco"
    },
    {
      "id": "050503",
      "nombre": "Ayna"
    },
    {
      "id": "050504",
      "nombre": "Chilcas"
    },
    {
      "id": "050505",
      "nombre": "Chungui"
    },
    {
      "id": "050506",
      "nombre": "Luis Carranza"
    },
    {
      "id": "050507",
      "nombre": "Santa Rosa"
    },
    {
      "id": "050508",
      "nombre": "Tambo"
    }
  ],
  "0506": [
    {
      "id": "050601",
      "nombre": "Puquio"
    },
    {
      "id": "050602",
      "nombre": "Aucara"
    },
    {
      "id": "050603",
      "nombre": "Cabana"
    },
    {
      "id": "050604",
      "nombre": "Carmen Salcedo"
    },
    {
      "id": "050605",
      "nombre": "Chaviqa"
    },
    {
      "id": "050606",
      "nombre": "Chipao"
    },
    {
      "id": "050607",
      "nombre": "Huac-Huas"
    },
    {
      "id": "050608",
      "nombre": "Laramate"
    },
    {
      "id": "050609",
      "nombre": "Leoncio Prado"
    },
    {
      "id": "050610",
      "nombre": "Llauta"
    },
    {
      "id": "050611",
      "nombre": "Lucanas"
    },
    {
      "id": "050612",
      "nombre": "Ocaqa"
    },
    {
      "id": "050613",
      "nombre": "Otoca"
    },
    {
      "id": "050614",
      "nombre": "Saisa"
    },
    {
      "id": "050615",
      "nombre": "San Cristobal"
    },
    {
      "id": "050616",
      "nombre": "San Juan"
    },
    {
      "id": "050617",
      "nombre": "San Pedro"
    },
    {
      "id": "050618",
      "nombre": "San Pedro de Palco"
    },
    {
      "id": "050619",
      "nombre": "Sancos"
    },
    {
      "id": "050620",
      "nombre": "Santa Ana de Huaycahuacho"
    },
    {
      "id": "050621",
      "nombre": "Santa Lucia"
    }
  ],
  "0507": [
    {
      "id": "050701",
      "nombre": "Coracora"
    },
    {
      "id": "050702",
      "nombre": "Chumpi"
    },
    {
      "id": "050703",
      "nombre": "Coronel Castaqeda"
    },
    {
      "id": "050704",
      "nombre": "Pacapausa"
    },
    {
      "id": "050705",
      "nombre": "Pullo"
    },
    {
      "id": "050706",
      "nombre": "Puyusca"
    },
    {
      "id": "050707",
      "nombre": "San Francisco de Ravacayco"
    },
    {
      "id": "050708",
      "nombre": "Upahuacho"
    }
  ],
  "0508": [
    {
      "id": "050801",
      "nombre": "Pausa"
    },
    {
      "id": "050802",
      "nombre": "Colta"
    },
    {
      "id": "050803",
      "nombre": "Corculla"
    },
    {
      "id": "050804",
      "nombre": "Lampa"
    },
    {
      "id": "050805",
      "nombre": "Marcabamba"
    },
    {
      "id": "050806",
      "nombre": "Oyolo"
    },
    {
      "id": "050807",
      "nombre": "Pararca"
    },
    {
      "id": "050808",
      "nombre": "San Javier de Alpabamba"
    },
    {
      "id": "050809",
      "nombre": "San Jose de Ushua"
    },
    {
      "id": "050810",
      "nombre": "Sara Sara"
    }
  ],
  "0509": [
    {
      "id": "050901",
      "nombre": "Querobamba"
    },
    {
      "id": "050902",
      "nombre": "Belen"
    },
    {
      "id": "050903",
      "nombre": "Chalcos"
    },
    {
      "id": "050904",
      "nombre": "Chilcayoc"
    },
    {
      "id": "050905",
      "nombre": "Huacaqa"
    },
    {
      "id": "050906",
      "nombre": "Morcolla"
    },
    {
      "id": "050907",
      "nombre": "Paico"
    },
    {
      "id": "050908",
      "nombre": "San Pedro de Larcay"
    },
    {
      "id": "050909",
      "nombre": "San Salvador de Quije"
    },
    {
      "id": "050910",
      "nombre": "Santiago de Paucaray"
    },
    {
      "id": "050911",
      "nombre": "Soras"
    }
  ],
  "0510": [
    {
      "id": "051001",
      "nombre": "Huancapi"
    },
    {
      "id": "051002",
      "nombre": "Alcamenca"
    },
    {
      "id": "051003",
      "nombre": "Apongo"
    },
    {
      "id": "051004",
      "nombre": "Asquipata"
    },
    {
      "id": "051005",
      "nombre": "Canaria"
    },
    {
      "id": "051006",
      "nombre": "Cayara"
    },
    {
      "id": "051007",
      "nombre": "Colca"
    },
    {
      "id": "051008",
      "nombre": "Huamanquiquia"
    },
    {
      "id": "051009",
      "nombre": "Huancaraylla"
    },
    {
      "id": "051010",
      "nombre": "Huaya"
    },
    {
      "id": "051011",
      "nombre": "Sarhua"
    },
    {
      "id": "051012",
      "nombre": "Vilcanchos"
    }
  ],
  "0511": [
    {
      "id": "051101",
      "nombre": "Vilcas Huaman"
    },
    {
      "id": "051102",
      "nombre": "Accomarca"
    },
    {
      "id": "051103",
      "nombre": "Carhuanca"
    },
    {
      "id": "051104",
      "nombre": "Concepcion"
    },
    {
      "id": "051105",
      "nombre": "Huambalpa"
    },
    {
      "id": "051106",
      "nombre": "Independencia"
    },
    {
      "id": "051107",
      "nombre": "Saurama"
    },
    {
      "id": "051108",
      "nombre": "Vischongo"
    }
  ],
  "0601": [
    {
      "id": "060101",
      "nombre": "Cajamarca"
    },
    {
      "id": "060102",
      "nombre": "Asuncion"
    },
    {
      "id": "060103",
      "nombre": "Chetilla"
    },
    {
      "id": "060104",
      "nombre": "Cospan"
    },
    {
      "id": "060105",
      "nombre": "Encaqada"
    },
    {
      "id": "060106",
      "nombre": "Jesus"
    },
    {
      "id": "060107",
      "nombre": "Llacanora"
    },
    {
      "id": "060108",
      "nombre": "Los Baqos del Inca"
    },
    {
      "id": "060109",
      "nombre": "Magdalena"
    },
    {
      "id": "060110",
      "nombre": "Matara"
    },
    {
      "id": "060111",
      "nombre": "Namora"
    },
    {
      "id": "060112",
      "nombre": "San Juan"
    }
  ],
  "0602": [
    {
      "id": "060201",
      "nombre": "Cajabamba"
    },
    {
      "id": "060202",
      "nombre": "Cachachi"
    },
    {
      "id": "060203",
      "nombre": "Condebamba"
    },
    {
      "id": "060204",
      "nombre": "Sitacocha"
    }
  ],
  "0603": [
    {
      "id": "060301",
      "nombre": "Celendin"
    },
    {
      "id": "060302",
      "nombre": "Chumuch"
    },
    {
      "id": "060303",
      "nombre": "Cortegana"
    },
    {
      "id": "060304",
      "nombre": "Huasmin"
    },
    {
      "id": "060305",
      "nombre": "Jorge Chavez"
    },
    {
      "id": "060306",
      "nombre": "Jose Galvez"
    },
    {
      "id": "060307",
      "nombre": "Miguel Iglesias"
    },
    {
      "id": "060308",
      "nombre": "Oxamarca"
    },
    {
      "id": "060309",
      "nombre": "Sorochuco"
    },
    {
      "id": "060310",
      "nombre": "Sucre"
    },
    {
      "id": "060311",
      "nombre": "Utco"
    },
    {
      "id": "060312",
      "nombre": "La Libertad de Pallan"
    }
  ],
  "0604": [
    {
      "id": "060401",
      "nombre": "Chota"
    },
    {
      "id": "060402",
      "nombre": "Anguia"
    },
    {
      "id": "060403",
      "nombre": "Chadin"
    },
    {
      "id": "060404",
      "nombre": "Chiguirip"
    },
    {
      "id": "060405",
      "nombre": "Chimban"
    },
    {
      "id": "060406",
      "nombre": "Choropampa"
    },
    {
      "id": "060407",
      "nombre": "Cochabamba"
    },
    {
      "id": "060408",
      "nombre": "Conchan"
    },
    {
      "id": "060409",
      "nombre": "Huambos"
    },
    {
      "id": "060410",
      "nombre": "Lajas"
    },
    {
      "id": "060411",
      "nombre": "Llama"
    },
    {
      "id": "060412",
      "nombre": "Miracosta"
    },
    {
      "id": "060413",
      "nombre": "Paccha"
    },
    {
      "id": "060414",
      "nombre": "Pion"
    },
    {
      "id": "060415",
      "nombre": "Querocoto"
    },
    {
      "id": "060416",
      "nombre": "San Juan de Licupis"
    },
    {
      "id": "060417",
      "nombre": "Tacabamba"
    },
    {
      "id": "060418",
      "nombre": "Tocmoche"
    },
    {
      "id": "060419",
      "nombre": "Chalamarca"
    }
  ],
  "0605": [
    {
      "id": "060501",
      "nombre": "Contumaza"
    },
    {
      "id": "060502",
      "nombre": "Chilete"
    },
    {
      "id": "060503",
      "nombre": "Cupisnique"
    },
    {
      "id": "060504",
      "nombre": "Guzmango"
    },
    {
      "id": "060505",
      "nombre": "San Benito"
    },
    {
      "id": "060506",
      "nombre": "Santa Cruz de Toled"
    },
    {
      "id": "060507",
      "nombre": "Tantarica"
    },
    {
      "id": "060508",
      "nombre": "Yonan"
    }
  ],
  "0606": [
    {
      "id": "060601",
      "nombre": "Cutervo"
    },
    {
      "id": "060602",
      "nombre": "Callayuc"
    },
    {
      "id": "060603",
      "nombre": "Choros"
    },
    {
      "id": "060604",
      "nombre": "Cujillo"
    },
    {
      "id": "060605",
      "nombre": "La Ramada"
    },
    {
      "id": "060606",
      "nombre": "Pimpingos"
    },
    {
      "id": "060607",
      "nombre": "Querocotillo"
    },
    {
      "id": "060608",
      "nombre": "San Andres de Cutervo"
    },
    {
      "id": "060609",
      "nombre": "San Juan de Cutervo"
    },
    {
      "id": "060610",
      "nombre": "San Luis de Lucma"
    },
    {
      "id": "060611",
      "nombre": "Santa Cruz"
    },
    {
      "id": "060612",
      "nombre": "Santo Domingo de la Capilla"
    },
    {
      "id": "060613",
      "nombre": "Santo Tomas"
    },
    {
      "id": "060614",
      "nombre": "Socota"
    },
    {
      "id": "060615",
      "nombre": "Toribio Casanova"
    }
  ],
  "0607": [
    {
      "id": "060701",
      "nombre": "Bambamarca"
    },
    {
      "id": "060702",
      "nombre": "Chugur"
    },
    {
      "id": "060703",
      "nombre": "Hualgayoc"
    }
  ],
  "0608": [
    {
      "id": "060801",
      "nombre": "Jaen"
    },
    {
      "id": "060802",
      "nombre": "Bellavista"
    },
    {
      "id": "060803",
      "nombre": "Chontali"
    },
    {
      "id": "060804",
      "nombre": "Colasay"
    },
    {
      "id": "060805",
      "nombre": "Huabal"
    },
    {
      "id": "060806",
      "nombre": "Las Pirias"
    },
    {
      "id": "060807",
      "nombre": "Pomahuaca"
    },
    {
      "id": "060808",
      "nombre": "Pucara"
    },
    {
      "id": "060809",
      "nombre": "Sallique"
    },
    {
      "id": "060810",
      "nombre": "San Felipe"
    },
    {
      "id": "060811",
      "nombre": "San Jose del Alto"
    },
    {
      "id": "060812",
      "nombre": "Santa Rosa"
    }
  ],
  "0609": [
    {
      "id": "060901",
      "nombre": "San Ignacio"
    },
    {
      "id": "060902",
      "nombre": "Chirinos"
    },
    {
      "id": "060903",
      "nombre": "Huarango"
    },
    {
      "id": "060904",
      "nombre": "La Coipa"
    },
    {
      "id": "060905",
      "nombre": "Namballe"
    },
    {
      "id": "060906",
      "nombre": "San Jose de Lourdes"
    },
    {
      "id": "060907",
      "nombre": "Tabaconas"
    }
  ],
  "0610": [
    {
      "id": "061001",
      "nombre": "Pedro Galvez"
    },
    {
      "id": "061002",
      "nombre": "Chancay"
    },
    {
      "id": "061003",
      "nombre": "Eduardo Villanueva"
    },
    {
      "id": "061004",
      "nombre": "Gregorio Pita"
    },
    {
      "id": "061005",
      "nombre": "Ichocan"
    },
    {
      "id": "061006",
      "nombre": "Jose Manuel Quiroz"
    },
    {
      "id": "061007",
      "nombre": "Jose Sabogal"
    }
  ],
  "0611": [
    {
      "id": "061101",
      "nombre": "San Miguel"
    },
    {
      "id": "061102",
      "nombre": "Bolivar"
    },
    {
      "id": "061103",
      "nombre": "Calquis"
    },
    {
      "id": "061104",
      "nombre": "Catilluc"
    },
    {
      "id": "061105",
      "nombre": "El Prado"
    },
    {
      "id": "061106",
      "nombre": "La Florida"
    },
    {
      "id": "061107",
      "nombre": "Llapa"
    },
    {
      "id": "061108",
      "nombre": "Nanchoc"
    },
    {
      "id": "061109",
      "nombre": "Niepos"
    },
    {
      "id": "061110",
      "nombre": "San Gregorio"
    },
    {
      "id": "061111",
      "nombre": "San Silvestre de Cochan"
    },
    {
      "id": "061112",
      "nombre": "Tongod"
    },
    {
      "id": "061113",
      "nombre": "Union Agua Blanca"
    }
  ],
  "0612": [
    {
      "id": "061201",
      "nombre": "San Pablo"
    },
    {
      "id": "061202",
      "nombre": "San Bernardino"
    },
    {
      "id": "061203",
      "nombre": "San Luis"
    },
    {
      "id": "061204",
      "nombre": "Tumbaden"
    }
  ],
  "0613": [
    {
      "id": "061301",
      "nombre": "Santa Cruz"
    },
    {
      "id": "061302",
      "nombre": "Andabamba"
    },
    {
      "id": "061303",
      "nombre": "Catache"
    },
    {
      "id": "061304",
      "nombre": "Chancaybaqos"
    },
    {
      "id": "061305",
      "nombre": "La Esperanza"
    },
    {
      "id": "061306",
      "nombre": "Ninabamba"
    },
    {
      "id": "061307",
      "nombre": "Pulan"
    },
    {
      "id": "061308",
      "nombre": "Saucepampa"
    },
    {
      "id": "061309",
      "nombre": "Sexi"
    },
    {
      "id": "061310",
      "nombre": "Uticyacu"
    },
    {
      "id": "061311",
      "nombre": "Yauyucan"
    }
  ],
  "0701": [
    {
      "id": "070101",
      "nombre": "Callao"
    },
    {
      "id": "070102",
      "nombre": "Bellavista"
    },
    {
      "id": "070103",
      "nombre": "Carmen de la Legua Reynoso"
    },
    {
      "id": "070104",
      "nombre": "La Perla"
    },
    {
      "id": "070105",
      "nombre": "La Punta"
    },
    {
      "id": "070106",
      "nombre": "Ventanilla"
    },
    {
      "id": "070107",
      "nombre": "Mi Peru"
    }
  ],
  "0801": [
    {
      "id": "080101",
      "nombre": "Cusco"
    },
    {
      "id": "080102",
      "nombre": "Ccorca"
    },
    {
      "id": "080103",
      "nombre": "Poroy"
    },
    {
      "id": "080104",
      "nombre": "San Jeronimo"
    },
    {
      "id": "080105",
      "nombre": "San Sebastian"
    },
    {
      "id": "080106",
      "nombre": "Santiago"
    },
    {
      "id": "080107",
      "nombre": "Saylla"
    },
    {
      "id": "080108",
      "nombre": "Wanchaq"
    }
  ],
  "0802": [
    {
      "id": "080201",
      "nombre": "Acomayo"
    },
    {
      "id": "080202",
      "nombre": "Acopia"
    },
    {
      "id": "080203",
      "nombre": "Acos"
    },
    {
      "id": "080204",
      "nombre": "Mosoc Llacta"
    },
    {
      "id": "080205",
      "nombre": "Pomacanchi"
    },
    {
      "id": "080206",
      "nombre": "Rondocan"
    },
    {
      "id": "080207",
      "nombre": "Sangarara"
    }
  ],
  "0803": [
    {
      "id": "080301",
      "nombre": "Anta"
    },
    {
      "id": "080302",
      "nombre": "Ancahuasi"
    },
    {
      "id": "080303",
      "nombre": "Cachimayo"
    },
    {
      "id": "080304",
      "nombre": "Chinchaypujio"
    },
    {
      "id": "080305",
      "nombre": "Huarocondo"
    },
    {
      "id": "080306",
      "nombre": "Limatambo"
    },
    {
      "id": "080307",
      "nombre": "Mollepata"
    },
    {
      "id": "080308",
      "nombre": "Pucyura"
    },
    {
      "id": "080309",
      "nombre": "Zurite"
    }
  ],
  "0804": [
    {
      "id": "080401",
      "nombre": "Calca"
    },
    {
      "id": "080402",
      "nombre": "Coya"
    },
    {
      "id": "080403",
      "nombre": "Lamay"
    },
    {
      "id": "080404",
      "nombre": "Lares"
    },
    {
      "id": "080405",
      "nombre": "Pisac"
    },
    {
      "id": "080406",
      "nombre": "San Salvador"
    },
    {
      "id": "080407",
      "nombre": "Taray"
    },
    {
      "id": "080408",
      "nombre": "Yanatile"
    }
  ],
  "0805": [
    {
      "id": "080501",
      "nombre": "Yanaoca"
    },
    {
      "id": "080502",
      "nombre": "Checca"
    },
    {
      "id": "080503",
      "nombre": "Kunturkanki"
    },
    {
      "id": "080504",
      "nombre": "Langui"
    },
    {
      "id": "080505",
      "nombre": "Layo"
    },
    {
      "id": "080506",
      "nombre": "Pampamarca"
    },
    {
      "id": "080507",
      "nombre": "Quehue"
    },
    {
      "id": "080508",
      "nombre": "Tupac Amaru"
    }
  ],
  "0806": [
    {
      "id": "080601",
      "nombre": "Sicuani"
    },
    {
      "id": "080602",
      "nombre": "Checacupe"
    },
    {
      "id": "080603",
      "nombre": "Combapata"
    },
    {
      "id": "080604",
      "nombre": "Marangani"
    },
    {
      "id": "080605",
      "nombre": "Pitumarca"
    },
    {
      "id": "080606",
      "nombre": "San Pablo"
    },
    {
      "id": "080607",
      "nombre": "San Pedro"
    },
    {
      "id": "080608",
      "nombre": "Tinta"
    }
  ],
  "0807": [
    {
      "id": "080701",
      "nombre": "Santo Tomas"
    },
    {
      "id": "080702",
      "nombre": "Capacmarca"
    },
    {
      "id": "080703",
      "nombre": "Chamaca"
    },
    {
      "id": "080704",
      "nombre": "Colquemarca"
    },
    {
      "id": "080705",
      "nombre": "Livitaca"
    },
    {
      "id": "080706",
      "nombre": "Llusco"
    },
    {
      "id": "080707",
      "nombre": "Quiqota"
    },
    {
      "id": "080708",
      "nombre": "Velille"
    }
  ],
  "0808": [
    {
      "id": "080801",
      "nombre": "Espinar"
    },
    {
      "id": "080802",
      "nombre": "Condoroma"
    },
    {
      "id": "080803",
      "nombre": "Coporaque"
    },
    {
      "id": "080804",
      "nombre": "Ocoruro"
    },
    {
      "id": "080805",
      "nombre": "Pallpata"
    },
    {
      "id": "080806",
      "nombre": "Pichigua"
    },
    {
      "id": "080807",
      "nombre": "Suyckutambo"
    },
    {
      "id": "080808",
      "nombre": "Alto Pichigua"
    }
  ],
  "0809": [
    {
      "id": "080901",
      "nombre": "Santa Ana"
    },
    {
      "id": "080902",
      "nombre": "Echarate"
    },
    {
      "id": "080903",
      "nombre": "Huayopata"
    },
    {
      "id": "080904",
      "nombre": "Maranura"
    },
    {
      "id": "080905",
      "nombre": "Ocobamba"
    },
    {
      "id": "080906",
      "nombre": "Quellouno"
    },
    {
      "id": "080907",
      "nombre": "Quimbiri"
    },
    {
      "id": "080908",
      "nombre": "Santa Teresa"
    },
    {
      "id": "080909",
      "nombre": "Vilcabamba"
    },
    {
      "id": "080910",
      "nombre": "Pichari"
    }
  ],
  "0810": [
    {
      "id": "081001",
      "nombre": "Paruro"
    },
    {
      "id": "081002",
      "nombre": "Accha"
    },
    {
      "id": "081003",
      "nombre": "Ccapi"
    },
    {
      "id": "081004",
      "nombre": "Colcha"
    },
    {
      "id": "081005",
      "nombre": "Huanoquite"
    },
    {
      "id": "081006",
      "nombre": "Omacha"
    },
    {
      "id": "081007",
      "nombre": "Paccaritambo"
    },
    {
      "id": "081008",
      "nombre": "Pillpinto"
    },
    {
      "id": "081009",
      "nombre": "Yaurisque"
    }
  ],
  "0811": [
    {
      "id": "081101",
      "nombre": "Paucartambo"
    },
    {
      "id": "081102",
      "nombre": "Caicay"
    },
    {
      "id": "081103",
      "nombre": "Challabamba"
    },
    {
      "id": "081104",
      "nombre": "Colquepata"
    },
    {
      "id": "081105",
      "nombre": "Huancarani"
    },
    {
      "id": "081106",
      "nombre": "Kosqipata"
    }
  ],
  "0812": [
    {
      "id": "081201",
      "nombre": "Urcos"
    },
    {
      "id": "081202",
      "nombre": "Andahuaylillas"
    },
    {
      "id": "081203",
      "nombre": "Camanti"
    },
    {
      "id": "081204",
      "nombre": "Ccarhuayo"
    },
    {
      "id": "081205",
      "nombre": "Ccatca"
    },
    {
      "id": "081206",
      "nombre": "Cusipata"
    },
    {
      "id": "081207",
      "nombre": "Huaro"
    },
    {
      "id": "081208",
      "nombre": "Lucre"
    },
    {
      "id": "081209",
      "nombre": "Marcapata"
    },
    {
      "id": "081210",
      "nombre": "Ocongate"
    },
    {
      "id": "081211",
      "nombre": "Oropesa"
    },
    {
      "id": "081212",
      "nombre": "Quiquijana"
    }
  ],
  "0813": [
    {
      "id": "081301",
      "nombre": "Urubamba"
    },
    {
      "id": "081302",
      "nombre": "Chinchero"
    },
    {
      "id": "081303",
      "nombre": "Huayllabamba"
    },
    {
      "id": "081304",
      "nombre": "Machupicchu"
    },
    {
      "id": "081305",
      "nombre": "Maras"
    },
    {
      "id": "081306",
      "nombre": "Ollantaytambo"
    },
    {
      "id": "081307",
      "nombre": "Yucay"
    }
  ],
  "0901": [
    {
      "id": "090101",
      "nombre": "Huancavelica"
    },
    {
      "id": "090102",
      "nombre": "Acobambilla"
    },
    {
      "id": "090103",
      "nombre": "Acoria"
    },
    {
      "id": "090104",
      "nombre": "Conayca"
    },
    {
      "id": "090105",
      "nombre": "Cuenca"
    },
    {
      "id": "090106",
      "nombre": "Huachocolpa"
    },
    {
      "id": "090107",
      "nombre": "Huayllahuara"
    },
    {
      "id": "090108",
      "nombre": "Izcuchaca"
    },
    {
      "id": "090109",
      "nombre": "Laria"
    },
    {
      "id": "090110",
      "nombre": "Manta"
    },
    {
      "id": "090111",
      "nombre": "Mariscal Caceres"
    },
    {
      "id": "090112",
      "nombre": "Moya"
    },
    {
      "id": "090113",
      "nombre": "Nuevo Occoro"
    },
    {
      "id": "090114",
      "nombre": "Palca"
    },
    {
      "id": "090115",
      "nombre": "Pilchaca"
    },
    {
      "id": "090116",
      "nombre": "Vilca"
    },
    {
      "id": "090117",
      "nombre": "Yauli"
    },
    {
      "id": "090118",
      "nombre": "Ascensión"
    },
    {
      "id": "090119",
      "nombre": "Huando"
    }
  ],
  "0902": [
    {
      "id": "090201",
      "nombre": "Acobamba"
    },
    {
      "id": "090202",
      "nombre": "Andabamba"
    },
    {
      "id": "090203",
      "nombre": "Anta"
    },
    {
      "id": "090204",
      "nombre": "Caja"
    },
    {
      "id": "090205",
      "nombre": "Marcas"
    },
    {
      "id": "090206",
      "nombre": "Paucara"
    },
    {
      "id": "090207",
      "nombre": "Pomacocha"
    },
    {
      "id": "090208",
      "nombre": "Rosario"
    }
  ],
  "0903": [
    {
      "id": "090301",
      "nombre": "Lircay"
    },
    {
      "id": "090302",
      "nombre": "Anchonga"
    },
    {
      "id": "090303",
      "nombre": "Callanmarca"
    },
    {
      "id": "090304",
      "nombre": "Ccochaccasa"
    },
    {
      "id": "090305",
      "nombre": "Chincho"
    },
    {
      "id": "090306",
      "nombre": "Congalla"
    },
    {
      "id": "090307",
      "nombre": "Huanca-Huanca"
    },
    {
      "id": "090308",
      "nombre": "Huayllay Grande"
    },
    {
      "id": "090309",
      "nombre": "Julcamarca"
    },
    {
      "id": "090310",
      "nombre": "San Antonio de Antaparco"
    },
    {
      "id": "090311",
      "nombre": "Santo Tomas de Pata"
    },
    {
      "id": "090312",
      "nombre": "Secclla"
    }
  ],
  "0904": [
    {
      "id": "090401",
      "nombre": "Castrovirreyna"
    },
    {
      "id": "090402",
      "nombre": "Arma"
    },
    {
      "id": "090403",
      "nombre": "Aurahua"
    },
    {
      "id": "090404",
      "nombre": "Capillas"
    },
    {
      "id": "090405",
      "nombre": "Chupamarca"
    },
    {
      "id": "090406",
      "nombre": "Cocas"
    },
    {
      "id": "090407",
      "nombre": "Huachos"
    },
    {
      "id": "090408",
      "nombre": "Huamatambo"
    },
    {
      "id": "090409",
      "nombre": "Mollepampa"
    },
    {
      "id": "090410",
      "nombre": "San Juan"
    },
    {
      "id": "090411",
      "nombre": "Santa Ana"
    },
    {
      "id": "090412",
      "nombre": "Tantara"
    },
    {
      "id": "090413",
      "nombre": "Ticrapo"
    }
  ],
  "0905": [
    {
      "id": "090501",
      "nombre": "Churcampa"
    },
    {
      "id": "090502",
      "nombre": "Anco"
    },
    {
      "id": "090503",
      "nombre": "Chinchihuasi"
    },
    {
      "id": "090504",
      "nombre": "El Carmen"
    },
    {
      "id": "090505",
      "nombre": "La Merced"
    },
    {
      "id": "090506",
      "nombre": "Locroja"
    },
    {
      "id": "090507",
      "nombre": "Paucarbamba"
    },
    {
      "id": "090508",
      "nombre": "San Miguel de Mayocc"
    },
    {
      "id": "090509",
      "nombre": "San Pedro de Coris"
    },
    {
      "id": "090510",
      "nombre": "Pachamarca"
    }
  ],
  "0906": [
    {
      "id": "090601",
      "nombre": "Huaytara"
    },
    {
      "id": "090602",
      "nombre": "Ayavi"
    },
    {
      "id": "090603",
      "nombre": "Cordova"
    },
    {
      "id": "090604",
      "nombre": "Huayacundo Arma"
    },
    {
      "id": "090605",
      "nombre": "Laramarca"
    },
    {
      "id": "090606",
      "nombre": "Ocoyo"
    },
    {
      "id": "090607",
      "nombre": "Pilpichaca"
    },
    {
      "id": "090608",
      "nombre": "Querco"
    },
    {
      "id": "090609",
      "nombre": "Quito-Arma"
    },
    {
      "id": "090610",
      "nombre": "San Antonio de Cusicancha"
    },
    {
      "id": "090611",
      "nombre": "San Francisco de Sangayaico"
    },
    {
      "id": "090612",
      "nombre": "San Isidro"
    },
    {
      "id": "090613",
      "nombre": "Santiago de Chocorvos"
    },
    {
      "id": "090614",
      "nombre": "Santiago de Quirahuara"
    },
    {
      "id": "090615",
      "nombre": "Santo Domingo de Capillas"
    },
    {
      "id": "090616",
      "nombre": "Tambo"
    }
  ],
  "0907": [
    {
      "id": "090701",
      "nombre": "Pampas"
    },
    {
      "id": "090702",
      "nombre": "Acostambo"
    },
    {
      "id": "090703",
      "nombre": "Acraquia"
    },
    {
      "id": "090704",
      "nombre": "Ahuaycha"
    },
    {
      "id": "090705",
      "nombre": "Colcabamba"
    },
    {
      "id": "090706",
      "nombre": "Daniel Hernandez"
    },
    {
      "id": "090707",
      "nombre": "Huachocolpa"
    },
    {
      "id": "090708",
      "nombre": "Huando"
    },
    {
      "id": "090709",
      "nombre": "Huaribamba"
    },
    {
      "id": "090710",
      "nombre": "Qahuimpuquio"
    },
    {
      "id": "090711",
      "nombre": "Pazos"
    },
    {
      "id": "090712",
      "nombre": "Pachamarca"
    },
    {
      "id": "090713",
      "nombre": "Quishuar"
    },
    {
      "id": "090714",
      "nombre": "Salcabamba"
    },
    {
      "id": "090715",
      "nombre": "Salcahuasi"
    },
    {
      "id": "090716",
      "nombre": "San Marcos de Rocchac"
    },
    {
      "id": "090717",
      "nombre": "Surcubamba"
    },
    {
      "id": "090718",
      "nombre": "Tintay Puncu"
    }
  ]
};

// Función helper para obtener provincias por departamento
export const getProvinciasByDepartamento = (departamentoId) => {
  return provincias[departamentoId] || [];
};

// Función helper para obtener distritos por provincia
export const getDistritosByProvincia = (provinciaId) => {
  return distritos[provinciaId] || [];
};
